"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[122],{

/***/ 6317:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L1": function() { return /* binding */ Tp; },
/* harmony export */   "Rq": function() { return /* binding */ Op; },
/* harmony export */   "l8": function() { return /* binding */ wp; }
/* harmony export */ });
/* unused harmony exports AgeSchema, BookAppointmentInputSchema, BookAppointmentResponseSchema, BookingError, ClinicalFocus, ClinicalFocusSchema, DeliveryMethod, DeliveryMethodSchema, Ethnicity, EthnicitySchema, Gender, GenderSchema, GetAvailabilitiesInputSchema, GetProvidersInputSchema, LanguageSchema, LocationFacility, LocationFacilitySchema, LocationState, LocationStateSchema, LocationStateToNameMapping, Modality, ProviderFilter, ProviderSelection, Scheduler, Slots, TherapeuticModalitySchema, WeekCalendar */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3935);



var gn = { exports: {} }, Nt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var pa;
function to() {
  if (pa) return Nt;
  pa = 1;
  var e = react__WEBPACK_IMPORTED_MODULE_0__, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, c, u) {
    var d, h = {}, v = null, m = null;
    u !== void 0 && (v = "" + u), c.key !== void 0 && (v = "" + c.key), c.ref !== void 0 && (m = c.ref);
    for (d in c) n.call(c, d) && !i.hasOwnProperty(d) && (h[d] = c[d]);
    if (s && s.defaultProps) for (d in c = s.defaultProps, c) h[d] === void 0 && (h[d] = c[d]);
    return { $$typeof: t, type: s, key: v, ref: m, props: h, _owner: a.current };
  }
  return Nt.Fragment = r, Nt.jsx = o, Nt.jsxs = o, Nt;
}
var $t = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ga;
function ro() {
  return ga || (ga = 1,  false && 0), $t;
}
 true ? gn.exports = to() : 0;
var f = gn.exports, Qa = typeof global == "object" && global && global.Object === Object && global, no = typeof self == "object" && self && self.Object === Object && self, Ee = Qa || no || Function("return this")(), xt = Ee.Symbol, ei = Object.prototype, ao = ei.hasOwnProperty, io = ei.toString, Mt = xt ? xt.toStringTag : void 0;
function so(e) {
  var t = ao.call(e, Mt), r = e[Mt];
  try {
    e[Mt] = void 0;
    var n = !0;
  } catch {
  }
  var a = io.call(e);
  return n && (t ? e[Mt] = r : delete e[Mt]), a;
}
var oo = Object.prototype, co = oo.toString;
function lo(e) {
  return co.call(e);
}
var uo = "[object Null]", fo = "[object Undefined]", va = xt ? xt.toStringTag : void 0;
function ot(e) {
  return e == null ? e === void 0 ? fo : uo : va && va in Object(e) ? so(e) : lo(e);
}
function Ot(e) {
  return e != null && typeof e == "object";
}
var ho = "[object Symbol]";
function ti(e) {
  return typeof e == "symbol" || Ot(e) && ot(e) == ho;
}
function mo(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = Array(n); ++r < n; )
    a[r] = t(e[r], r, e);
  return a;
}
var Bt = Array.isArray, po = 1 / 0, ya = xt ? xt.prototype : void 0, ba = ya ? ya.toString : void 0;
function ri(e) {
  if (typeof e == "string")
    return e;
  if (Bt(e))
    return mo(e, ri) + "";
  if (ti(e))
    return ba ? ba.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -po ? "-0" : t;
}
var go = /\s/;
function vo(e) {
  for (var t = e.length; t-- && go.test(e.charAt(t)); )
    ;
  return t;
}
var yo = /^\s+/;
function bo(e) {
  return e && e.slice(0, vo(e) + 1).replace(yo, "");
}
function Pe(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var xa = NaN, xo = /^[-+]0x[0-9a-f]+$/i, _o = /^0b[01]+$/i, wo = /^0o[0-7]+$/i, To = parseInt;
function _a(e) {
  if (typeof e == "number")
    return e;
  if (ti(e))
    return xa;
  if (Pe(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Pe(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = bo(e);
  var r = _o.test(e);
  return r || wo.test(e) ? To(e.slice(2), r ? 2 : 8) : xo.test(e) ? xa : +e;
}
function ni(e) {
  return e;
}
var ko = "[object AsyncFunction]", Eo = "[object Function]", So = "[object GeneratorFunction]", Oo = "[object Proxy]";
function Mn(e) {
  if (!Pe(e))
    return !1;
  var t = ot(e);
  return t == Eo || t == So || t == ko || t == Oo;
}
var an = Ee["__core-js_shared__"], wa = function() {
  var e = /[^.]+$/.exec(an && an.keys && an.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function jo(e) {
  return !!wa && wa in e;
}
var Po = Function.prototype, Co = Po.toString;
function ct(e) {
  if (e != null) {
    try {
      return Co.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var No = /[\\^$.*+?()[\]{}|]/g, $o = /^\[object .+?Constructor\]$/, Mo = Function.prototype, Ao = Object.prototype, Do = Mo.toString, Ro = Ao.hasOwnProperty, Io = RegExp(
  "^" + Do.call(Ro).replace(No, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Fo(e) {
  if (!Pe(e) || jo(e))
    return !1;
  var t = Mn(e) ? Io : $o;
  return t.test(ct(e));
}
function Lo(e, t) {
  return e == null ? void 0 : e[t];
}
function lt(e, t) {
  var r = Lo(e, t);
  return Fo(r) ? r : void 0;
}
var vn = lt(Ee, "WeakMap"), Ta = Object.create, Wo = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!Pe(t))
      return {};
    if (Ta)
      return Ta(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}();
function Zo(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
function Vo() {
}
function Bo(e, t) {
  var r = -1, n = e.length;
  for (t || (t = Array(n)); ++r < n; )
    t[r] = e[r];
  return t;
}
var Ho = 800, Yo = 16, Uo = Date.now;
function zo(e) {
  var t = 0, r = 0;
  return function() {
    var n = Uo(), a = Yo - (n - r);
    if (r = n, a > 0) {
      if (++t >= Ho)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
function Go(e) {
  return function() {
    return e;
  };
}
var _r = function() {
  try {
    var e = lt(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), qo = _r ? function(e, t) {
  return _r(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Go(t),
    writable: !0
  });
} : ni, Xo = zo(qo);
function Ko(e, t, r, n) {
  for (var a = e.length, i = r + -1; ++i < a; )
    if (t(e[i], i, e))
      return i;
  return -1;
}
function Jo(e) {
  return e !== e;
}
function Qo(e, t, r) {
  for (var n = r - 1, a = e.length; ++n < a; )
    if (e[n] === t)
      return n;
  return -1;
}
function ec(e, t, r) {
  return t === t ? Qo(e, t, r) : Ko(e, Jo, r);
}
function tc(e, t) {
  var r = e == null ? 0 : e.length;
  return !!r && ec(e, t, 0) > -1;
}
var rc = 9007199254740991, nc = /^(?:0|[1-9]\d*)$/;
function ai(e, t) {
  var r = typeof e;
  return t = t ?? rc, !!t && (r == "number" || r != "symbol" && nc.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function An(e, t, r) {
  t == "__proto__" && _r ? _r(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
function Fr(e, t) {
  return e === t || e !== e && t !== t;
}
var ac = Object.prototype, ic = ac.hasOwnProperty;
function sc(e, t, r) {
  var n = e[t];
  (!(ic.call(e, t) && Fr(n, r)) || r === void 0 && !(t in e)) && An(e, t, r);
}
function oc(e, t, r, n) {
  var a = !r;
  r || (r = {});
  for (var i = -1, o = t.length; ++i < o; ) {
    var s = t[i], c = void 0;
    c === void 0 && (c = e[s]), a ? An(r, s, c) : sc(r, s, c);
  }
  return r;
}
var ka = Math.max;
function cc(e, t, r) {
  return t = ka(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, a = -1, i = ka(n.length - t, 0), o = Array(i); ++a < i; )
      o[a] = n[t + a];
    a = -1;
    for (var s = Array(t + 1); ++a < t; )
      s[a] = n[a];
    return s[t] = r(o), Zo(e, this, s);
  };
}
function lc(e, t) {
  return Xo(cc(e, t, ni), e + "");
}
var uc = 9007199254740991;
function ii(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= uc;
}
function Lr(e) {
  return e != null && ii(e.length) && !Mn(e);
}
function dc(e, t, r) {
  if (!Pe(r))
    return !1;
  var n = typeof t;
  return (n == "number" ? Lr(r) && ai(t, r.length) : n == "string" && t in r) ? Fr(r[t], e) : !1;
}
function fc(e) {
  return lc(function(t, r) {
    var n = -1, a = r.length, i = a > 1 ? r[a - 1] : void 0, o = a > 2 ? r[2] : void 0;
    for (i = e.length > 3 && typeof i == "function" ? (a--, i) : void 0, o && dc(r[0], r[1], o) && (i = a < 3 ? void 0 : i, a = 1), t = Object(t); ++n < a; ) {
      var s = r[n];
      s && e(t, s, n, i);
    }
    return t;
  });
}
var hc = Object.prototype;
function Wr(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || hc;
  return e === r;
}
function mc(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var pc = "[object Arguments]";
function Ea(e) {
  return Ot(e) && ot(e) == pc;
}
var si = Object.prototype, gc = si.hasOwnProperty, vc = si.propertyIsEnumerable, wr = Ea(/* @__PURE__ */ function() {
  return arguments;
}()) ? Ea : function(e) {
  return Ot(e) && gc.call(e, "callee") && !vc.call(e, "callee");
};
function yc() {
  return !1;
}
var oi = typeof exports == "object" && exports && !exports.nodeType && exports, Sa = oi && typeof module == "object" && module && !module.nodeType && module, bc = Sa && Sa.exports === oi, Oa = bc ? Ee.Buffer : void 0, xc = Oa ? Oa.isBuffer : void 0, Dn = xc || yc, _c = "[object Arguments]", wc = "[object Array]", Tc = "[object Boolean]", kc = "[object Date]", Ec = "[object Error]", Sc = "[object Function]", Oc = "[object Map]", jc = "[object Number]", Pc = "[object Object]", Cc = "[object RegExp]", Nc = "[object Set]", $c = "[object String]", Mc = "[object WeakMap]", Ac = "[object ArrayBuffer]", Dc = "[object DataView]", Rc = "[object Float32Array]", Ic = "[object Float64Array]", Fc = "[object Int8Array]", Lc = "[object Int16Array]", Wc = "[object Int32Array]", Zc = "[object Uint8Array]", Vc = "[object Uint8ClampedArray]", Bc = "[object Uint16Array]", Hc = "[object Uint32Array]", G = {};
G[Rc] = G[Ic] = G[Fc] = G[Lc] = G[Wc] = G[Zc] = G[Vc] = G[Bc] = G[Hc] = !0;
G[_c] = G[wc] = G[Ac] = G[Tc] = G[Dc] = G[kc] = G[Ec] = G[Sc] = G[Oc] = G[jc] = G[Pc] = G[Cc] = G[Nc] = G[$c] = G[Mc] = !1;
function Yc(e) {
  return Ot(e) && ii(e.length) && !!G[ot(e)];
}
function Uc(e) {
  return function(t) {
    return e(t);
  };
}
var ci = typeof exports == "object" && exports && !exports.nodeType && exports, Wt = ci && typeof module == "object" && module && !module.nodeType && module, zc = Wt && Wt.exports === ci, sn = zc && Qa.process, ja = function() {
  try {
    var e = Wt && Wt.require && Wt.require("util").types;
    return e || sn && sn.binding && sn.binding("util");
  } catch {
  }
}(), Pa = ja && ja.isTypedArray, Rn = Pa ? Uc(Pa) : Yc;
function Gc(e, t) {
  var r = Bt(e), n = !r && wr(e), a = !r && !n && Dn(e), i = !r && !n && !a && Rn(e), o = r || n || a || i, s = o ? mc(e.length, String) : [], c = s.length;
  for (var u in e)
    o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    ai(u, c)) || s.push(u);
  return s;
}
function li(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var qc = li(Object.keys, Object), Xc = Object.prototype, Kc = Xc.hasOwnProperty;
function Jc(e) {
  if (!Wr(e))
    return qc(e);
  var t = [];
  for (var r in Object(e))
    Kc.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
function Qc(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var el = Object.prototype, tl = el.hasOwnProperty;
function rl(e) {
  if (!Pe(e))
    return Qc(e);
  var t = Wr(e), r = [];
  for (var n in e)
    n == "constructor" && (t || !tl.call(e, n)) || r.push(n);
  return r;
}
function ui(e) {
  return Lr(e) ? Gc(e) : rl(e);
}
var Ht = lt(Object, "create");
function nl() {
  this.__data__ = Ht ? Ht(null) : {}, this.size = 0;
}
function al(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var il = "__lodash_hash_undefined__", sl = Object.prototype, ol = sl.hasOwnProperty;
function cl(e) {
  var t = this.__data__;
  if (Ht) {
    var r = t[e];
    return r === il ? void 0 : r;
  }
  return ol.call(t, e) ? t[e] : void 0;
}
var ll = Object.prototype, ul = ll.hasOwnProperty;
function dl(e) {
  var t = this.__data__;
  return Ht ? t[e] !== void 0 : ul.call(t, e);
}
var fl = "__lodash_hash_undefined__";
function hl(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Ht && t === void 0 ? fl : t, this;
}
function nt(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
nt.prototype.clear = nl;
nt.prototype.delete = al;
nt.prototype.get = cl;
nt.prototype.has = dl;
nt.prototype.set = hl;
function ml() {
  this.__data__ = [], this.size = 0;
}
function Zr(e, t) {
  for (var r = e.length; r--; )
    if (Fr(e[r][0], t))
      return r;
  return -1;
}
var pl = Array.prototype, gl = pl.splice;
function vl(e) {
  var t = this.__data__, r = Zr(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : gl.call(t, r, 1), --this.size, !0;
}
function yl(e) {
  var t = this.__data__, r = Zr(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function bl(e) {
  return Zr(this.__data__, e) > -1;
}
function xl(e, t) {
  var r = this.__data__, n = Zr(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
function Ie(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Ie.prototype.clear = ml;
Ie.prototype.delete = vl;
Ie.prototype.get = yl;
Ie.prototype.has = bl;
Ie.prototype.set = xl;
var Yt = lt(Ee, "Map");
function _l() {
  this.size = 0, this.__data__ = {
    hash: new nt(),
    map: new (Yt || Ie)(),
    string: new nt()
  };
}
function wl(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function Vr(e, t) {
  var r = e.__data__;
  return wl(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function Tl(e) {
  var t = Vr(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function kl(e) {
  return Vr(this, e).get(e);
}
function El(e) {
  return Vr(this, e).has(e);
}
function Sl(e, t) {
  var r = Vr(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
function ut(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
ut.prototype.clear = _l;
ut.prototype.delete = Tl;
ut.prototype.get = kl;
ut.prototype.has = El;
ut.prototype.set = Sl;
function Ol(e) {
  return e == null ? "" : ri(e);
}
var di = li(Object.getPrototypeOf, Object), jl = "[object Object]", Pl = Function.prototype, Cl = Object.prototype, fi = Pl.toString, Nl = Cl.hasOwnProperty, $l = fi.call(Object);
function Ml(e) {
  if (!Ot(e) || ot(e) != jl)
    return !1;
  var t = di(e);
  if (t === null)
    return !0;
  var r = Nl.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && fi.call(r) == $l;
}
function Al(e, t, r) {
  var n = -1, a = e.length;
  t < 0 && (t = -t > a ? 0 : a + t), r = r > a ? a : r, r < 0 && (r += a), a = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var i = Array(a); ++n < a; )
    i[n] = e[n + t];
  return i;
}
function Dl(e, t, r) {
  var n = e.length;
  return r = r === void 0 ? n : r, !t && r >= n ? e : Al(e, t, r);
}
var Rl = "\\ud800-\\udfff", Il = "\\u0300-\\u036f", Fl = "\\ufe20-\\ufe2f", Ll = "\\u20d0-\\u20ff", Wl = Il + Fl + Ll, Zl = "\\ufe0e\\ufe0f", Vl = "\\u200d", Bl = RegExp("[" + Vl + Rl + Wl + Zl + "]");
function hi(e) {
  return Bl.test(e);
}
function Hl(e) {
  return e.split("");
}
var mi = "\\ud800-\\udfff", Yl = "\\u0300-\\u036f", Ul = "\\ufe20-\\ufe2f", zl = "\\u20d0-\\u20ff", Gl = Yl + Ul + zl, ql = "\\ufe0e\\ufe0f", Xl = "[" + mi + "]", yn = "[" + Gl + "]", bn = "\\ud83c[\\udffb-\\udfff]", Kl = "(?:" + yn + "|" + bn + ")", pi = "[^" + mi + "]", gi = "(?:\\ud83c[\\udde6-\\uddff]){2}", vi = "[\\ud800-\\udbff][\\udc00-\\udfff]", Jl = "\\u200d", yi = Kl + "?", bi = "[" + ql + "]?", Ql = "(?:" + Jl + "(?:" + [pi, gi, vi].join("|") + ")" + bi + yi + ")*", eu = bi + yi + Ql, tu = "(?:" + [pi + yn + "?", yn, gi, vi, Xl].join("|") + ")", ru = RegExp(bn + "(?=" + bn + ")|" + tu + eu, "g");
function nu(e) {
  return e.match(ru) || [];
}
function au(e) {
  return hi(e) ? nu(e) : Hl(e);
}
function iu(e) {
  return function(t) {
    t = Ol(t);
    var r = hi(t) ? au(t) : void 0, n = r ? r[0] : t.charAt(0), a = r ? Dl(r, 1).join("") : t.slice(1);
    return n[e]() + a;
  };
}
var xi = iu("toUpperCase");
function su() {
  this.__data__ = new Ie(), this.size = 0;
}
function ou(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
function cu(e) {
  return this.__data__.get(e);
}
function lu(e) {
  return this.__data__.has(e);
}
var uu = 200;
function du(e, t) {
  var r = this.__data__;
  if (r instanceof Ie) {
    var n = r.__data__;
    if (!Yt || n.length < uu - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new ut(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
function jt(e) {
  var t = this.__data__ = new Ie(e);
  this.size = t.size;
}
jt.prototype.clear = su;
jt.prototype.delete = ou;
jt.prototype.get = cu;
jt.prototype.has = lu;
jt.prototype.set = du;
var _i = typeof exports == "object" && exports && !exports.nodeType && exports, Ca = _i && typeof module == "object" && module && !module.nodeType && module, fu = Ca && Ca.exports === _i, Na = fu ? Ee.Buffer : void 0;
Na && Na.allocUnsafe;
function hu(e, t) {
  return e.slice();
}
var xn = lt(Ee, "DataView"), _n = lt(Ee, "Promise"), yt = lt(Ee, "Set"), $a = "[object Map]", mu = "[object Object]", Ma = "[object Promise]", Aa = "[object Set]", Da = "[object WeakMap]", Ra = "[object DataView]", pu = ct(xn), gu = ct(Yt), vu = ct(_n), yu = ct(yt), bu = ct(vn), Ke = ot;
(xn && Ke(new xn(new ArrayBuffer(1))) != Ra || Yt && Ke(new Yt()) != $a || _n && Ke(_n.resolve()) != Ma || yt && Ke(new yt()) != Aa || vn && Ke(new vn()) != Da) && (Ke = function(e) {
  var t = ot(e), r = t == mu ? e.constructor : void 0, n = r ? ct(r) : "";
  if (n)
    switch (n) {
      case pu:
        return Ra;
      case gu:
        return $a;
      case vu:
        return Ma;
      case yu:
        return Aa;
      case bu:
        return Da;
    }
  return t;
});
var Ia = Ee.Uint8Array;
function xu(e) {
  var t = new e.constructor(e.byteLength);
  return new Ia(t).set(new Ia(e)), t;
}
function _u(e, t) {
  var r = xu(e.buffer);
  return new e.constructor(r, e.byteOffset, e.length);
}
function wu(e) {
  return typeof e.constructor == "function" && !Wr(e) ? Wo(di(e)) : {};
}
var Tu = "__lodash_hash_undefined__";
function ku(e) {
  return this.__data__.set(e, Tu), this;
}
function Eu(e) {
  return this.__data__.has(e);
}
function Tr(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new ut(); ++t < r; )
    this.add(e[t]);
}
Tr.prototype.add = Tr.prototype.push = ku;
Tr.prototype.has = Eu;
function Su(e, t) {
  return e.has(t);
}
function wi(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
function Ou(e) {
  return function(t, r, n) {
    for (var a = -1, i = Object(t), o = n(t), s = o.length; s--; ) {
      var c = o[++a];
      if (r(i[c], c, i) === !1)
        break;
    }
    return t;
  };
}
var ju = Ou(), on = function() {
  return Ee.Date.now();
}, Pu = "Expected a function", Cu = Math.max, Nu = Math.min;
function $u(e, t, r) {
  var n, a, i, o, s, c, u = 0, d = !1, h = !1, v = !0;
  if (typeof e != "function")
    throw new TypeError(Pu);
  t = _a(t) || 0, Pe(r) && (d = !!r.leading, h = "maxWait" in r, i = h ? Cu(_a(r.maxWait) || 0, t) : i, v = "trailing" in r ? !!r.trailing : v);
  function m(F) {
    var z = n, k = a;
    return n = a = void 0, u = F, o = e.apply(k, z), o;
  }
  function y(F) {
    return u = F, s = setTimeout(C, t), d ? m(F) : o;
  }
  function w(F) {
    var z = F - c, k = F - u, Q = t - z;
    return h ? Nu(Q, i - k) : Q;
  }
  function O(F) {
    var z = F - c, k = F - u;
    return c === void 0 || z >= t || z < 0 || h && k >= i;
  }
  function C() {
    var F = on();
    if (O(F))
      return S(F);
    s = setTimeout(C, w(F));
  }
  function S(F) {
    return s = void 0, v && n ? m(F) : (n = a = void 0, o);
  }
  function J() {
    s !== void 0 && clearTimeout(s), u = 0, n = c = a = s = void 0;
  }
  function U() {
    return s === void 0 ? o : S(on());
  }
  function ae() {
    var F = on(), z = O(F);
    if (n = arguments, a = this, c = F, z) {
      if (s === void 0)
        return y(c);
      if (h)
        return clearTimeout(s), s = setTimeout(C, t), m(c);
    }
    return s === void 0 && (s = setTimeout(C, t)), o;
  }
  return ae.cancel = J, ae.flush = U, ae;
}
function wn(e, t, r) {
  (r !== void 0 && !Fr(e[t], r) || r === void 0 && !(t in e)) && An(e, t, r);
}
function Mu(e) {
  return Ot(e) && Lr(e);
}
function Tn(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
function Au(e) {
  return oc(e, ui(e));
}
function Du(e, t, r, n, a, i, o) {
  var s = Tn(e, r), c = Tn(t, r), u = o.get(c);
  if (u) {
    wn(e, r, u);
    return;
  }
  var d = i ? i(s, c, r + "", e, t, o) : void 0, h = d === void 0;
  if (h) {
    var v = Bt(c), m = !v && Dn(c), y = !v && !m && Rn(c);
    d = c, v || m || y ? Bt(s) ? d = s : Mu(s) ? d = Bo(s) : m ? (h = !1, d = hu(c)) : y ? (h = !1, d = _u(c)) : d = [] : Ml(c) || wr(c) ? (d = s, wr(s) ? d = Au(s) : (!Pe(s) || Mn(s)) && (d = wu(c))) : h = !1;
  }
  h && (o.set(c, d), a(d, c, n, i, o), o.delete(c)), wn(e, r, d);
}
function Ti(e, t, r, n, a) {
  e !== t && ju(t, function(i, o) {
    if (a || (a = new jt()), Pe(i))
      Du(e, t, o, r, Ti, n, a);
    else {
      var s = n ? n(Tn(e, o), i, o + "", e, t, a) : void 0;
      s === void 0 && (s = i), wn(e, o, s);
    }
  }, ui);
}
var Ru = "[object Map]", Iu = "[object Set]", Fu = Object.prototype, Lu = Fu.hasOwnProperty;
function _t(e) {
  if (e == null)
    return !0;
  if (Lr(e) && (Bt(e) || typeof e == "string" || typeof e.splice == "function" || Dn(e) || Rn(e) || wr(e)))
    return !e.length;
  var t = Ke(e);
  if (t == Ru || t == Iu)
    return !e.size;
  if (Wr(e))
    return !Jc(e).length;
  for (var r in e)
    if (Lu.call(e, r))
      return !1;
  return !0;
}
function Br(e) {
  return e == null;
}
var Wu = fc(function(e, t, r) {
  Ti(e, t, r);
}), Zu = 1 / 0, Vu = yt && 1 / wi(new yt([, -0]))[1] == Zu ? function(e) {
  return new yt(e);
} : Vo, Bu = 200;
function Hu(e, t, r) {
  var n = -1, a = tc, i = e.length, o = !0, s = [], c = s;
  if (i >= Bu) {
    var u = Vu(e);
    if (u)
      return wi(u);
    o = !1, a = Su, c = new Tr();
  } else
    c = s;
  e:
    for (; ++n < i; ) {
      var d = e[n], h = d;
      if (d = d !== 0 ? d : 0, o && h === h) {
        for (var v = c.length; v--; )
          if (c[v] === h)
            continue e;
        s.push(d);
      } else a(c, h, r) || (c !== s && c.push(h), s.push(d));
    }
  return s;
}
function ki(e) {
  return e && e.length ? Hu(e) : [];
}
function Ei(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (r = Ei(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function I() {
  for (var e, t, r = 0, n = "", a = arguments.length; r < a; r++) (e = arguments[r]) && (t = Ei(e)) && (n && (n += " "), n += t);
  return n;
}
var W;
(function(e) {
  e.assertEqual = (a) => a;
  function t(a) {
  }
  e.assertIs = t;
  function r(a) {
    throw new Error();
  }
  e.assertNever = r, e.arrayToEnum = (a) => {
    const i = {};
    for (const o of a)
      i[o] = o;
    return i;
  }, e.getValidEnumValues = (a) => {
    const i = e.objectKeys(a).filter((s) => typeof a[a[s]] != "number"), o = {};
    for (const s of i)
      o[s] = a[s];
    return e.objectValues(o);
  }, e.objectValues = (a) => e.objectKeys(a).map(function(i) {
    return a[i];
  }), e.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const i = [];
    for (const o in a)
      Object.prototype.hasOwnProperty.call(a, o) && i.push(o);
    return i;
  }, e.find = (a, i) => {
    for (const o of a)
      if (i(o))
        return o;
  }, e.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && isFinite(a) && Math.floor(a) === a;
  function n(a, i = " | ") {
    return a.map((o) => typeof o == "string" ? `'${o}'` : o).join(i);
  }
  e.joinValues = n, e.jsonStringifyReplacer = (a, i) => typeof i == "bigint" ? i.toString() : i;
})(W || (W = {}));
var kn;
(function(e) {
  e.mergeShapes = (t, r) => ({
    ...t,
    ...r
    // second overwrites first
  });
})(kn || (kn = {}));
const _ = W.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Ve = (e) => {
  switch (typeof e) {
    case "undefined":
      return _.undefined;
    case "string":
      return _.string;
    case "number":
      return isNaN(e) ? _.nan : _.number;
    case "boolean":
      return _.boolean;
    case "function":
      return _.function;
    case "bigint":
      return _.bigint;
    case "symbol":
      return _.symbol;
    case "object":
      return Array.isArray(e) ? _.array : e === null ? _.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? _.promise : typeof Map < "u" && e instanceof Map ? _.map : typeof Set < "u" && e instanceof Set ? _.set : typeof Date < "u" && e instanceof Date ? _.date : _.object;
    default:
      return _.unknown;
  }
}, g = W.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), Yu = (e) => JSON.stringify(e, null, 2).replace(/"([^"]+)":/g, "$1:");
class ge extends Error {
  constructor(t) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = t;
  }
  get errors() {
    return this.issues;
  }
  format(t) {
    const r = t || function(i) {
      return i.message;
    }, n = { _errors: [] }, a = (i) => {
      for (const o of i.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(a);
        else if (o.code === "invalid_return_type")
          a(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          a(o.argumentsError);
        else if (o.path.length === 0)
          n._errors.push(r(o));
        else {
          let s = n, c = 0;
          for (; c < o.path.length; ) {
            const u = o.path[c];
            c === o.path.length - 1 ? (s[u] = s[u] || { _errors: [] }, s[u]._errors.push(r(o))) : s[u] = s[u] || { _errors: [] }, s = s[u], c++;
          }
        }
    };
    return a(this), n;
  }
  static assert(t) {
    if (!(t instanceof ge))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, W.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (r) => r.message) {
    const r = {}, n = [];
    for (const a of this.issues)
      a.path.length > 0 ? (r[a.path[0]] = r[a.path[0]] || [], r[a.path[0]].push(t(a))) : n.push(t(a));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
ge.create = (e) => new ge(e);
const wt = (e, t) => {
  let r;
  switch (e.code) {
    case g.invalid_type:
      e.received === _.undefined ? r = "Required" : r = `Expected ${e.expected}, received ${e.received}`;
      break;
    case g.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(e.expected, W.jsonStringifyReplacer)}`;
      break;
    case g.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${W.joinValues(e.keys, ", ")}`;
      break;
    case g.invalid_union:
      r = "Invalid input";
      break;
    case g.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${W.joinValues(e.options)}`;
      break;
    case g.invalid_enum_value:
      r = `Invalid enum value. Expected ${W.joinValues(e.options)}, received '${e.received}'`;
      break;
    case g.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case g.invalid_return_type:
      r = "Invalid function return type";
      break;
    case g.invalid_date:
      r = "Invalid date";
      break;
    case g.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (r = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? r = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? r = `Invalid input: must end with "${e.validation.endsWith}"` : W.assertNever(e.validation) : e.validation !== "regex" ? r = `Invalid ${e.validation}` : r = "Invalid";
      break;
    case g.too_small:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : r = "Invalid input";
      break;
    case g.too_big:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? r = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : r = "Invalid input";
      break;
    case g.custom:
      r = "Invalid input";
      break;
    case g.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case g.not_multiple_of:
      r = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case g.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = t.defaultError, W.assertNever(e);
  }
  return { message: r };
};
let Si = wt;
function Uu(e) {
  Si = e;
}
function kr() {
  return Si;
}
const Er = (e) => {
  const { data: t, path: r, errorMaps: n, issueData: a } = e, i = [...r, ...a.path || []], o = {
    ...a,
    path: i
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: i,
      message: a.message
    };
  let s = "";
  const c = n.filter((u) => !!u).slice().reverse();
  for (const u of c)
    s = u(o, { data: t, defaultError: s }).message;
  return {
    ...a,
    path: i,
    message: s
  };
}, zu = [];
function b(e, t) {
  const r = kr(), n = Er({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      e.schemaErrorMap,
      r,
      r === wt ? void 0 : wt
      // then global default map
    ].filter((a) => !!a)
  });
  e.common.issues.push(n);
}
class le {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, r) {
    const n = [];
    for (const a of r) {
      if (a.status === "aborted")
        return P;
      a.status === "dirty" && t.dirty(), n.push(a.value);
    }
    return { status: t.value, value: n };
  }
  static async mergeObjectAsync(t, r) {
    const n = [];
    for (const a of r) {
      const i = await a.key, o = await a.value;
      n.push({
        key: i,
        value: o
      });
    }
    return le.mergeObjectSync(t, n);
  }
  static mergeObjectSync(t, r) {
    const n = {};
    for (const a of r) {
      const { key: i, value: o } = a;
      if (i.status === "aborted" || o.status === "aborted")
        return P;
      i.status === "dirty" && t.dirty(), o.status === "dirty" && t.dirty(), i.value !== "__proto__" && (typeof o.value < "u" || a.alwaysSet) && (n[i.value] = o.value);
    }
    return { status: t.value, value: n };
  }
}
const P = Object.freeze({
  status: "aborted"
}), vt = (e) => ({ status: "dirty", value: e }), fe = (e) => ({ status: "valid", value: e }), En = (e) => e.status === "aborted", Sn = (e) => e.status === "dirty", Ut = (e) => e.status === "valid", zt = (e) => typeof Promise < "u" && e instanceof Promise;
function Sr(e, t, r, n) {
  if (typeof t == "function" ? e !== t || !n : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return t.get(e);
}
function Oi(e, t, r, n, a) {
  if (typeof t == "function" ? e !== t || !a : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return t.set(e, r), r;
}
var T;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(T || (T = {}));
var Rt, It;
class Ce {
  constructor(t, r, n, a) {
    this._cachedPath = [], this.parent = t, this.data = r, this._path = n, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Fa = (e, t) => {
  if (Ut(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new ge(e.common.issues);
      return this._error = r, this._error;
    }
  };
};
function M(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: r, required_error: n, description: a } = e;
  if (t && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: a } : { errorMap: (o, s) => {
    var c, u;
    const { message: d } = e;
    return o.code === "invalid_enum_value" ? { message: d ?? s.defaultError } : typeof s.data > "u" ? { message: (c = d ?? n) !== null && c !== void 0 ? c : s.defaultError } : o.code !== "invalid_type" ? { message: s.defaultError } : { message: (u = d ?? r) !== null && u !== void 0 ? u : s.defaultError };
  }, description: a };
}
class D {
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return Ve(t.data);
  }
  _getOrReturnCtx(t, r) {
    return r || {
      common: t.parent.common,
      data: t.data,
      parsedType: Ve(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new le(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: Ve(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const r = this._parse(t);
    if (zt(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(t) {
    const r = this._parse(t);
    return Promise.resolve(r);
  }
  parse(t, r) {
    const n = this.safeParse(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(t, r) {
    var n;
    const a = {
      common: {
        issues: [],
        async: (n = r == null ? void 0 : r.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Ve(t)
    }, i = this._parseSync({ data: t, path: a.path, parent: a });
    return Fa(a, i);
  }
  async parseAsync(t, r) {
    const n = await this.safeParseAsync(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(t, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Ve(t)
    }, a = this._parse({ data: t, path: n.path, parent: n }), i = await (zt(a) ? a : Promise.resolve(a));
    return Fa(n, i);
  }
  refine(t, r) {
    const n = (a) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(a) : r;
    return this._refinement((a, i) => {
      const o = t(a), s = () => i.addIssue({
        code: g.custom,
        ...n(a)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((c) => c ? !0 : (s(), !1)) : o ? !0 : (s(), !1);
    });
  }
  refinement(t, r) {
    return this._refinement((n, a) => t(n) ? !0 : (a.addIssue(typeof r == "function" ? r(n, a) : r), !1));
  }
  _refinement(t) {
    return new Te({
      schema: this,
      typeName: j.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  optional() {
    return Oe.create(this, this._def);
  }
  nullable() {
    return ze.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return we.create(this, this._def);
  }
  promise() {
    return kt.create(this, this._def);
  }
  or(t) {
    return Kt.create([this, t], this._def);
  }
  and(t) {
    return Jt.create(this, t, this._def);
  }
  transform(t) {
    return new Te({
      ...M(this._def),
      schema: this,
      typeName: j.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const r = typeof t == "function" ? t : () => t;
    return new nr({
      ...M(this._def),
      innerType: this,
      defaultValue: r,
      typeName: j.ZodDefault
    });
  }
  brand() {
    return new In({
      typeName: j.ZodBranded,
      type: this,
      ...M(this._def)
    });
  }
  catch(t) {
    const r = typeof t == "function" ? t : () => t;
    return new ar({
      ...M(this._def),
      innerType: this,
      catchValue: r,
      typeName: j.ZodCatch
    });
  }
  describe(t) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return sr.create(this, t);
  }
  readonly() {
    return ir.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Gu = /^c[^\s-]{8,}$/i, qu = /^[0-9a-z]+$/, Xu = /^[0-9A-HJKMNP-TV-Z]{26}$/, Ku = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Ju = /^[a-z0-9_-]{21}$/i, Qu = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, ed = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, td = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let cn;
const rd = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, nd = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, ad = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, ji = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", id = new RegExp(`^${ji}$`);
function Pi(e) {
  let t = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`), t;
}
function sd(e) {
  return new RegExp(`^${Pi(e)}$`);
}
function Ci(e) {
  let t = `${ji}T${Pi(e)}`;
  const r = [];
  return r.push(e.local ? "Z?" : "Z"), e.offset && r.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${r.join("|")})`, new RegExp(`^${t}$`);
}
function od(e, t) {
  return !!((t === "v4" || !t) && rd.test(e) || (t === "v6" || !t) && nd.test(e));
}
class _e extends D {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== _.string) {
      const i = this._getOrReturnCtx(t);
      return b(i, {
        code: g.invalid_type,
        expected: _.string,
        received: i.parsedType
      }), P;
    }
    const n = new le();
    let a;
    for (const i of this._def.checks)
      if (i.kind === "min")
        t.data.length < i.value && (a = this._getOrReturnCtx(t, a), b(a, {
          code: g.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "max")
        t.data.length > i.value && (a = this._getOrReturnCtx(t, a), b(a, {
          code: g.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "length") {
        const o = t.data.length > i.value, s = t.data.length < i.value;
        (o || s) && (a = this._getOrReturnCtx(t, a), o ? b(a, {
          code: g.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : s && b(a, {
          code: g.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), n.dirty());
      } else if (i.kind === "email")
        ed.test(t.data) || (a = this._getOrReturnCtx(t, a), b(a, {
          validation: "email",
          code: g.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "emoji")
        cn || (cn = new RegExp(td, "u")), cn.test(t.data) || (a = this._getOrReturnCtx(t, a), b(a, {
          validation: "emoji",
          code: g.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "uuid")
        Ku.test(t.data) || (a = this._getOrReturnCtx(t, a), b(a, {
          validation: "uuid",
          code: g.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "nanoid")
        Ju.test(t.data) || (a = this._getOrReturnCtx(t, a), b(a, {
          validation: "nanoid",
          code: g.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid")
        Gu.test(t.data) || (a = this._getOrReturnCtx(t, a), b(a, {
          validation: "cuid",
          code: g.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid2")
        qu.test(t.data) || (a = this._getOrReturnCtx(t, a), b(a, {
          validation: "cuid2",
          code: g.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "ulid")
        Xu.test(t.data) || (a = this._getOrReturnCtx(t, a), b(a, {
          validation: "ulid",
          code: g.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "url")
        try {
          new URL(t.data);
        } catch {
          a = this._getOrReturnCtx(t, a), b(a, {
            validation: "url",
            code: g.invalid_string,
            message: i.message
          }), n.dirty();
        }
      else i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(t.data) || (a = this._getOrReturnCtx(t, a), b(a, {
        validation: "regex",
        code: g.invalid_string,
        message: i.message
      }), n.dirty())) : i.kind === "trim" ? t.data = t.data.trim() : i.kind === "includes" ? t.data.includes(i.value, i.position) || (a = this._getOrReturnCtx(t, a), b(a, {
        code: g.invalid_string,
        validation: { includes: i.value, position: i.position },
        message: i.message
      }), n.dirty()) : i.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : i.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : i.kind === "startsWith" ? t.data.startsWith(i.value) || (a = this._getOrReturnCtx(t, a), b(a, {
        code: g.invalid_string,
        validation: { startsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "endsWith" ? t.data.endsWith(i.value) || (a = this._getOrReturnCtx(t, a), b(a, {
        code: g.invalid_string,
        validation: { endsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "datetime" ? Ci(i).test(t.data) || (a = this._getOrReturnCtx(t, a), b(a, {
        code: g.invalid_string,
        validation: "datetime",
        message: i.message
      }), n.dirty()) : i.kind === "date" ? id.test(t.data) || (a = this._getOrReturnCtx(t, a), b(a, {
        code: g.invalid_string,
        validation: "date",
        message: i.message
      }), n.dirty()) : i.kind === "time" ? sd(i).test(t.data) || (a = this._getOrReturnCtx(t, a), b(a, {
        code: g.invalid_string,
        validation: "time",
        message: i.message
      }), n.dirty()) : i.kind === "duration" ? Qu.test(t.data) || (a = this._getOrReturnCtx(t, a), b(a, {
        validation: "duration",
        code: g.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "ip" ? od(t.data, i.version) || (a = this._getOrReturnCtx(t, a), b(a, {
        validation: "ip",
        code: g.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64" ? ad.test(t.data) || (a = this._getOrReturnCtx(t, a), b(a, {
        validation: "base64",
        code: g.invalid_string,
        message: i.message
      }), n.dirty()) : W.assertNever(i);
    return { status: n.value, value: t.data };
  }
  _regex(t, r, n) {
    return this.refinement((a) => t.test(a), {
      validation: r,
      code: g.invalid_string,
      ...T.errToObj(n)
    });
  }
  _addCheck(t) {
    return new _e({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...T.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...T.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...T.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...T.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...T.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...T.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...T.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...T.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...T.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...T.errToObj(t) });
  }
  datetime(t) {
    var r, n;
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (r = t == null ? void 0 : t.offset) !== null && r !== void 0 ? r : !1,
      local: (n = t == null ? void 0 : t.local) !== null && n !== void 0 ? n : !1,
      ...T.errToObj(t == null ? void 0 : t.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      ...T.errToObj(t == null ? void 0 : t.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...T.errToObj(t) });
  }
  regex(t, r) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...T.errToObj(r)
    });
  }
  includes(t, r) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: r == null ? void 0 : r.position,
      ...T.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(t, r) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...T.errToObj(r)
    });
  }
  endsWith(t, r) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...T.errToObj(r)
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...T.errToObj(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...T.errToObj(r)
    });
  }
  length(t, r) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...T.errToObj(r)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(t) {
    return this.min(1, T.errToObj(t));
  }
  trim() {
    return new _e({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new _e({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new _e({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get minLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
_e.create = (e) => {
  var t;
  return new _e({
    checks: [],
    typeName: j.ZodString,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...M(e)
  });
};
function cd(e, t) {
  const r = (e.toString().split(".")[1] || "").length, n = (t.toString().split(".")[1] || "").length, a = r > n ? r : n, i = parseInt(e.toFixed(a).replace(".", "")), o = parseInt(t.toFixed(a).replace(".", ""));
  return i % o / Math.pow(10, a);
}
class He extends D {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== _.number) {
      const i = this._getOrReturnCtx(t);
      return b(i, {
        code: g.invalid_type,
        expected: _.number,
        received: i.parsedType
      }), P;
    }
    let n;
    const a = new le();
    for (const i of this._def.checks)
      i.kind === "int" ? W.isInteger(t.data) || (n = this._getOrReturnCtx(t, n), b(n, {
        code: g.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), a.dirty()) : i.kind === "min" ? (i.inclusive ? t.data < i.value : t.data <= i.value) && (n = this._getOrReturnCtx(t, n), b(n, {
        code: g.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), a.dirty()) : i.kind === "max" ? (i.inclusive ? t.data > i.value : t.data >= i.value) && (n = this._getOrReturnCtx(t, n), b(n, {
        code: g.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), a.dirty()) : i.kind === "multipleOf" ? cd(t.data, i.value) !== 0 && (n = this._getOrReturnCtx(t, n), b(n, {
        code: g.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), a.dirty()) : i.kind === "finite" ? Number.isFinite(t.data) || (n = this._getOrReturnCtx(t, n), b(n, {
        code: g.not_finite,
        message: i.message
      }), a.dirty()) : W.assertNever(i);
    return { status: a.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, T.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, T.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, T.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, T.toString(r));
  }
  setLimit(t, r, n, a) {
    return new He({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: T.toString(a)
        }
      ]
    });
  }
  _addCheck(t) {
    return new He({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: T.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: T.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: T.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: T.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: T.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: T.toString(r)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: T.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: T.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: T.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && W.isInteger(t.value));
  }
  get isFinite() {
    let t = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(t);
  }
}
He.create = (e) => new He({
  checks: [],
  typeName: j.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...M(e)
});
class Ye extends D {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = BigInt(t.data)), this._getType(t) !== _.bigint) {
      const i = this._getOrReturnCtx(t);
      return b(i, {
        code: g.invalid_type,
        expected: _.bigint,
        received: i.parsedType
      }), P;
    }
    let n;
    const a = new le();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? t.data < i.value : t.data <= i.value) && (n = this._getOrReturnCtx(t, n), b(n, {
        code: g.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), a.dirty()) : i.kind === "max" ? (i.inclusive ? t.data > i.value : t.data >= i.value) && (n = this._getOrReturnCtx(t, n), b(n, {
        code: g.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), a.dirty()) : i.kind === "multipleOf" ? t.data % i.value !== BigInt(0) && (n = this._getOrReturnCtx(t, n), b(n, {
        code: g.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), a.dirty()) : W.assertNever(i);
    return { status: a.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, T.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, T.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, T.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, T.toString(r));
  }
  setLimit(t, r, n, a) {
    return new Ye({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: T.toString(a)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Ye({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: T.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: T.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: T.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: T.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: T.toString(r)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
Ye.create = (e) => {
  var t;
  return new Ye({
    checks: [],
    typeName: j.ZodBigInt,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...M(e)
  });
};
class Gt extends D {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== _.boolean) {
      const n = this._getOrReturnCtx(t);
      return b(n, {
        code: g.invalid_type,
        expected: _.boolean,
        received: n.parsedType
      }), P;
    }
    return fe(t.data);
  }
}
Gt.create = (e) => new Gt({
  typeName: j.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...M(e)
});
class at extends D {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== _.date) {
      const i = this._getOrReturnCtx(t);
      return b(i, {
        code: g.invalid_type,
        expected: _.date,
        received: i.parsedType
      }), P;
    }
    if (isNaN(t.data.getTime())) {
      const i = this._getOrReturnCtx(t);
      return b(i, {
        code: g.invalid_date
      }), P;
    }
    const n = new le();
    let a;
    for (const i of this._def.checks)
      i.kind === "min" ? t.data.getTime() < i.value && (a = this._getOrReturnCtx(t, a), b(a, {
        code: g.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), n.dirty()) : i.kind === "max" ? t.data.getTime() > i.value && (a = this._getOrReturnCtx(t, a), b(a, {
        code: g.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), n.dirty()) : W.assertNever(i);
    return {
      status: n.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new at({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: T.toString(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: T.toString(r)
    });
  }
  get minDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
}
at.create = (e) => new at({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: j.ZodDate,
  ...M(e)
});
class Or extends D {
  _parse(t) {
    if (this._getType(t) !== _.symbol) {
      const n = this._getOrReturnCtx(t);
      return b(n, {
        code: g.invalid_type,
        expected: _.symbol,
        received: n.parsedType
      }), P;
    }
    return fe(t.data);
  }
}
Or.create = (e) => new Or({
  typeName: j.ZodSymbol,
  ...M(e)
});
class qt extends D {
  _parse(t) {
    if (this._getType(t) !== _.undefined) {
      const n = this._getOrReturnCtx(t);
      return b(n, {
        code: g.invalid_type,
        expected: _.undefined,
        received: n.parsedType
      }), P;
    }
    return fe(t.data);
  }
}
qt.create = (e) => new qt({
  typeName: j.ZodUndefined,
  ...M(e)
});
class Xt extends D {
  _parse(t) {
    if (this._getType(t) !== _.null) {
      const n = this._getOrReturnCtx(t);
      return b(n, {
        code: g.invalid_type,
        expected: _.null,
        received: n.parsedType
      }), P;
    }
    return fe(t.data);
  }
}
Xt.create = (e) => new Xt({
  typeName: j.ZodNull,
  ...M(e)
});
class Tt extends D {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return fe(t.data);
  }
}
Tt.create = (e) => new Tt({
  typeName: j.ZodAny,
  ...M(e)
});
class rt extends D {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return fe(t.data);
  }
}
rt.create = (e) => new rt({
  typeName: j.ZodUnknown,
  ...M(e)
});
class Ae extends D {
  _parse(t) {
    const r = this._getOrReturnCtx(t);
    return b(r, {
      code: g.invalid_type,
      expected: _.never,
      received: r.parsedType
    }), P;
  }
}
Ae.create = (e) => new Ae({
  typeName: j.ZodNever,
  ...M(e)
});
class jr extends D {
  _parse(t) {
    if (this._getType(t) !== _.undefined) {
      const n = this._getOrReturnCtx(t);
      return b(n, {
        code: g.invalid_type,
        expected: _.void,
        received: n.parsedType
      }), P;
    }
    return fe(t.data);
  }
}
jr.create = (e) => new jr({
  typeName: j.ZodVoid,
  ...M(e)
});
class we extends D {
  _parse(t) {
    const { ctx: r, status: n } = this._processInputParams(t), a = this._def;
    if (r.parsedType !== _.array)
      return b(r, {
        code: g.invalid_type,
        expected: _.array,
        received: r.parsedType
      }), P;
    if (a.exactLength !== null) {
      const o = r.data.length > a.exactLength.value, s = r.data.length < a.exactLength.value;
      (o || s) && (b(r, {
        code: o ? g.too_big : g.too_small,
        minimum: s ? a.exactLength.value : void 0,
        maximum: o ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), n.dirty());
    }
    if (a.minLength !== null && r.data.length < a.minLength.value && (b(r, {
      code: g.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), n.dirty()), a.maxLength !== null && r.data.length > a.maxLength.value && (b(r, {
      code: g.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((o, s) => a.type._parseAsync(new Ce(r, o, r.path, s)))).then((o) => le.mergeArray(n, o));
    const i = [...r.data].map((o, s) => a.type._parseSync(new Ce(r, o, r.path, s)));
    return le.mergeArray(n, i);
  }
  get element() {
    return this._def.type;
  }
  min(t, r) {
    return new we({
      ...this._def,
      minLength: { value: t, message: T.toString(r) }
    });
  }
  max(t, r) {
    return new we({
      ...this._def,
      maxLength: { value: t, message: T.toString(r) }
    });
  }
  length(t, r) {
    return new we({
      ...this._def,
      exactLength: { value: t, message: T.toString(r) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
we.create = (e, t) => new we({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: j.ZodArray,
  ...M(t)
});
function gt(e) {
  if (e instanceof X) {
    const t = {};
    for (const r in e.shape) {
      const n = e.shape[r];
      t[r] = Oe.create(gt(n));
    }
    return new X({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof we ? new we({
    ...e._def,
    type: gt(e.element)
  }) : e instanceof Oe ? Oe.create(gt(e.unwrap())) : e instanceof ze ? ze.create(gt(e.unwrap())) : e instanceof Ne ? Ne.create(e.items.map((t) => gt(t))) : e;
}
class X extends D {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), r = W.objectKeys(t);
    return this._cached = { shape: t, keys: r };
  }
  _parse(t) {
    if (this._getType(t) !== _.object) {
      const u = this._getOrReturnCtx(t);
      return b(u, {
        code: g.invalid_type,
        expected: _.object,
        received: u.parsedType
      }), P;
    }
    const { status: n, ctx: a } = this._processInputParams(t), { shape: i, keys: o } = this._getCached(), s = [];
    if (!(this._def.catchall instanceof Ae && this._def.unknownKeys === "strip"))
      for (const u in a.data)
        o.includes(u) || s.push(u);
    const c = [];
    for (const u of o) {
      const d = i[u], h = a.data[u];
      c.push({
        key: { status: "valid", value: u },
        value: d._parse(new Ce(a, h, a.path, u)),
        alwaysSet: u in a.data
      });
    }
    if (this._def.catchall instanceof Ae) {
      const u = this._def.unknownKeys;
      if (u === "passthrough")
        for (const d of s)
          c.push({
            key: { status: "valid", value: d },
            value: { status: "valid", value: a.data[d] }
          });
      else if (u === "strict")
        s.length > 0 && (b(a, {
          code: g.unrecognized_keys,
          keys: s
        }), n.dirty());
      else if (u !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const d of s) {
        const h = a.data[d];
        c.push({
          key: { status: "valid", value: d },
          value: u._parse(
            new Ce(a, h, a.path, d)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: d in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const d of c) {
        const h = await d.key, v = await d.value;
        u.push({
          key: h,
          value: v,
          alwaysSet: d.alwaysSet
        });
      }
      return u;
    }).then((u) => le.mergeObjectSync(n, u)) : le.mergeObjectSync(n, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return T.errToObj, new X({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (r, n) => {
          var a, i, o, s;
          const c = (o = (i = (a = this._def).errorMap) === null || i === void 0 ? void 0 : i.call(a, r, n).message) !== null && o !== void 0 ? o : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (s = T.errToObj(t).message) !== null && s !== void 0 ? s : c
          } : {
            message: c
          };
        }
      } : {}
    });
  }
  strip() {
    return new X({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new X({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new X({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new X({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: j.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, r) {
    return this.augment({ [t]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new X({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const r = {};
    return W.objectKeys(t).forEach((n) => {
      t[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new X({
      ...this._def,
      shape: () => r
    });
  }
  omit(t) {
    const r = {};
    return W.objectKeys(this.shape).forEach((n) => {
      t[n] || (r[n] = this.shape[n]);
    }), new X({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return gt(this);
  }
  partial(t) {
    const r = {};
    return W.objectKeys(this.shape).forEach((n) => {
      const a = this.shape[n];
      t && !t[n] ? r[n] = a : r[n] = a.optional();
    }), new X({
      ...this._def,
      shape: () => r
    });
  }
  required(t) {
    const r = {};
    return W.objectKeys(this.shape).forEach((n) => {
      if (t && !t[n])
        r[n] = this.shape[n];
      else {
        let i = this.shape[n];
        for (; i instanceof Oe; )
          i = i._def.innerType;
        r[n] = i;
      }
    }), new X({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return Ni(W.objectKeys(this.shape));
  }
}
X.create = (e, t) => new X({
  shape: () => e,
  unknownKeys: "strip",
  catchall: Ae.create(),
  typeName: j.ZodObject,
  ...M(t)
});
X.strictCreate = (e, t) => new X({
  shape: () => e,
  unknownKeys: "strict",
  catchall: Ae.create(),
  typeName: j.ZodObject,
  ...M(t)
});
X.lazycreate = (e, t) => new X({
  shape: e,
  unknownKeys: "strip",
  catchall: Ae.create(),
  typeName: j.ZodObject,
  ...M(t)
});
class Kt extends D {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = this._def.options;
    function a(i) {
      for (const s of i)
        if (s.result.status === "valid")
          return s.result;
      for (const s of i)
        if (s.result.status === "dirty")
          return r.common.issues.push(...s.ctx.common.issues), s.result;
      const o = i.map((s) => new ge(s.ctx.common.issues));
      return b(r, {
        code: g.invalid_union,
        unionErrors: o
      }), P;
    }
    if (r.common.async)
      return Promise.all(n.map(async (i) => {
        const o = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: r.data,
            path: r.path,
            parent: o
          }),
          ctx: o
        };
      })).then(a);
    {
      let i;
      const o = [];
      for (const c of n) {
        const u = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, d = c._parseSync({
          data: r.data,
          path: r.path,
          parent: u
        });
        if (d.status === "valid")
          return d;
        d.status === "dirty" && !i && (i = { result: d, ctx: u }), u.common.issues.length && o.push(u.common.issues);
      }
      if (i)
        return r.common.issues.push(...i.ctx.common.issues), i.result;
      const s = o.map((c) => new ge(c));
      return b(r, {
        code: g.invalid_union,
        unionErrors: s
      }), P;
    }
  }
  get options() {
    return this._def.options;
  }
}
Kt.create = (e, t) => new Kt({
  options: e,
  typeName: j.ZodUnion,
  ...M(t)
});
const Me = (e) => e instanceof er ? Me(e.schema) : e instanceof Te ? Me(e.innerType()) : e instanceof tr ? [e.value] : e instanceof Ue ? e.options : e instanceof rr ? W.objectValues(e.enum) : e instanceof nr ? Me(e._def.innerType) : e instanceof qt ? [void 0] : e instanceof Xt ? [null] : e instanceof Oe ? [void 0, ...Me(e.unwrap())] : e instanceof ze ? [null, ...Me(e.unwrap())] : e instanceof In || e instanceof ir ? Me(e.unwrap()) : e instanceof ar ? Me(e._def.innerType) : [];
class Hr extends D {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== _.object)
      return b(r, {
        code: g.invalid_type,
        expected: _.object,
        received: r.parsedType
      }), P;
    const n = this.discriminator, a = r.data[n], i = this.optionsMap.get(a);
    return i ? r.common.async ? i._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : i._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (b(r, {
      code: g.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), P);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, r, n) {
    const a = /* @__PURE__ */ new Map();
    for (const i of r) {
      const o = Me(i.shape[t]);
      if (!o.length)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const s of o) {
        if (a.has(s))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(s)}`);
        a.set(s, i);
      }
    }
    return new Hr({
      typeName: j.ZodDiscriminatedUnion,
      discriminator: t,
      options: r,
      optionsMap: a,
      ...M(n)
    });
  }
}
function On(e, t) {
  const r = Ve(e), n = Ve(t);
  if (e === t)
    return { valid: !0, data: e };
  if (r === _.object && n === _.object) {
    const a = W.objectKeys(t), i = W.objectKeys(e).filter((s) => a.indexOf(s) !== -1), o = { ...e, ...t };
    for (const s of i) {
      const c = On(e[s], t[s]);
      if (!c.valid)
        return { valid: !1 };
      o[s] = c.data;
    }
    return { valid: !0, data: o };
  } else if (r === _.array && n === _.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const a = [];
    for (let i = 0; i < e.length; i++) {
      const o = e[i], s = t[i], c = On(o, s);
      if (!c.valid)
        return { valid: !1 };
      a.push(c.data);
    }
    return { valid: !0, data: a };
  } else return r === _.date && n === _.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class Jt extends D {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), a = (i, o) => {
      if (En(i) || En(o))
        return P;
      const s = On(i.value, o.value);
      return s.valid ? ((Sn(i) || Sn(o)) && r.dirty(), { status: r.value, value: s.data }) : (b(n, {
        code: g.invalid_intersection_types
      }), P);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([i, o]) => a(i, o)) : a(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
Jt.create = (e, t, r) => new Jt({
  left: e,
  right: t,
  typeName: j.ZodIntersection,
  ...M(r)
});
class Ne extends D {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== _.array)
      return b(n, {
        code: g.invalid_type,
        expected: _.array,
        received: n.parsedType
      }), P;
    if (n.data.length < this._def.items.length)
      return b(n, {
        code: g.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), P;
    !this._def.rest && n.data.length > this._def.items.length && (b(n, {
      code: g.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const i = [...n.data].map((o, s) => {
      const c = this._def.items[s] || this._def.rest;
      return c ? c._parse(new Ce(n, o, n.path, s)) : null;
    }).filter((o) => !!o);
    return n.common.async ? Promise.all(i).then((o) => le.mergeArray(r, o)) : le.mergeArray(r, i);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new Ne({
      ...this._def,
      rest: t
    });
  }
}
Ne.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Ne({
    items: e,
    typeName: j.ZodTuple,
    rest: null,
    ...M(t)
  });
};
class Qt extends D {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== _.object)
      return b(n, {
        code: g.invalid_type,
        expected: _.object,
        received: n.parsedType
      }), P;
    const a = [], i = this._def.keyType, o = this._def.valueType;
    for (const s in n.data)
      a.push({
        key: i._parse(new Ce(n, s, n.path, s)),
        value: o._parse(new Ce(n, n.data[s], n.path, s)),
        alwaysSet: s in n.data
      });
    return n.common.async ? le.mergeObjectAsync(r, a) : le.mergeObjectSync(r, a);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, r, n) {
    return r instanceof D ? new Qt({
      keyType: t,
      valueType: r,
      typeName: j.ZodRecord,
      ...M(n)
    }) : new Qt({
      keyType: _e.create(),
      valueType: t,
      typeName: j.ZodRecord,
      ...M(r)
    });
  }
}
class Pr extends D {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== _.map)
      return b(n, {
        code: g.invalid_type,
        expected: _.map,
        received: n.parsedType
      }), P;
    const a = this._def.keyType, i = this._def.valueType, o = [...n.data.entries()].map(([s, c], u) => ({
      key: a._parse(new Ce(n, s, n.path, [u, "key"])),
      value: i._parse(new Ce(n, c, n.path, [u, "value"]))
    }));
    if (n.common.async) {
      const s = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const c of o) {
          const u = await c.key, d = await c.value;
          if (u.status === "aborted" || d.status === "aborted")
            return P;
          (u.status === "dirty" || d.status === "dirty") && r.dirty(), s.set(u.value, d.value);
        }
        return { status: r.value, value: s };
      });
    } else {
      const s = /* @__PURE__ */ new Map();
      for (const c of o) {
        const u = c.key, d = c.value;
        if (u.status === "aborted" || d.status === "aborted")
          return P;
        (u.status === "dirty" || d.status === "dirty") && r.dirty(), s.set(u.value, d.value);
      }
      return { status: r.value, value: s };
    }
  }
}
Pr.create = (e, t, r) => new Pr({
  valueType: t,
  keyType: e,
  typeName: j.ZodMap,
  ...M(r)
});
class it extends D {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== _.set)
      return b(n, {
        code: g.invalid_type,
        expected: _.set,
        received: n.parsedType
      }), P;
    const a = this._def;
    a.minSize !== null && n.data.size < a.minSize.value && (b(n, {
      code: g.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), r.dirty()), a.maxSize !== null && n.data.size > a.maxSize.value && (b(n, {
      code: g.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), r.dirty());
    const i = this._def.valueType;
    function o(c) {
      const u = /* @__PURE__ */ new Set();
      for (const d of c) {
        if (d.status === "aborted")
          return P;
        d.status === "dirty" && r.dirty(), u.add(d.value);
      }
      return { status: r.value, value: u };
    }
    const s = [...n.data.values()].map((c, u) => i._parse(new Ce(n, c, n.path, u)));
    return n.common.async ? Promise.all(s).then((c) => o(c)) : o(s);
  }
  min(t, r) {
    return new it({
      ...this._def,
      minSize: { value: t, message: T.toString(r) }
    });
  }
  max(t, r) {
    return new it({
      ...this._def,
      maxSize: { value: t, message: T.toString(r) }
    });
  }
  size(t, r) {
    return this.min(t, r).max(t, r);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
it.create = (e, t) => new it({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: j.ZodSet,
  ...M(t)
});
class bt extends D {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== _.function)
      return b(r, {
        code: g.invalid_type,
        expected: _.function,
        received: r.parsedType
      }), P;
    function n(s, c) {
      return Er({
        data: s,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          kr(),
          wt
        ].filter((u) => !!u),
        issueData: {
          code: g.invalid_arguments,
          argumentsError: c
        }
      });
    }
    function a(s, c) {
      return Er({
        data: s,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          kr(),
          wt
        ].filter((u) => !!u),
        issueData: {
          code: g.invalid_return_type,
          returnTypeError: c
        }
      });
    }
    const i = { errorMap: r.common.contextualErrorMap }, o = r.data;
    if (this._def.returns instanceof kt) {
      const s = this;
      return fe(async function(...c) {
        const u = new ge([]), d = await s._def.args.parseAsync(c, i).catch((m) => {
          throw u.addIssue(n(c, m)), u;
        }), h = await Reflect.apply(o, this, d);
        return await s._def.returns._def.type.parseAsync(h, i).catch((m) => {
          throw u.addIssue(a(h, m)), u;
        });
      });
    } else {
      const s = this;
      return fe(function(...c) {
        const u = s._def.args.safeParse(c, i);
        if (!u.success)
          throw new ge([n(c, u.error)]);
        const d = Reflect.apply(o, this, u.data), h = s._def.returns.safeParse(d, i);
        if (!h.success)
          throw new ge([a(d, h.error)]);
        return h.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...t) {
    return new bt({
      ...this._def,
      args: Ne.create(t).rest(rt.create())
    });
  }
  returns(t) {
    return new bt({
      ...this._def,
      returns: t
    });
  }
  implement(t) {
    return this.parse(t);
  }
  strictImplement(t) {
    return this.parse(t);
  }
  static create(t, r, n) {
    return new bt({
      args: t || Ne.create([]).rest(rt.create()),
      returns: r || rt.create(),
      typeName: j.ZodFunction,
      ...M(n)
    });
  }
}
class er extends D {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
er.create = (e, t) => new er({
  getter: e,
  typeName: j.ZodLazy,
  ...M(t)
});
class tr extends D {
  _parse(t) {
    if (t.data !== this._def.value) {
      const r = this._getOrReturnCtx(t);
      return b(r, {
        received: r.data,
        code: g.invalid_literal,
        expected: this._def.value
      }), P;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
tr.create = (e, t) => new tr({
  value: e,
  typeName: j.ZodLiteral,
  ...M(t)
});
function Ni(e, t) {
  return new Ue({
    values: e,
    typeName: j.ZodEnum,
    ...M(t)
  });
}
class Ue extends D {
  constructor() {
    super(...arguments), Rt.set(this, void 0);
  }
  _parse(t) {
    if (typeof t.data != "string") {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return b(r, {
        expected: W.joinValues(n),
        received: r.parsedType,
        code: g.invalid_type
      }), P;
    }
    if (Sr(this, Rt) || Oi(this, Rt, new Set(this._def.values)), !Sr(this, Rt).has(t.data)) {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return b(r, {
        received: r.data,
        code: g.invalid_enum_value,
        options: n
      }), P;
    }
    return fe(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Values() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  extract(t, r = this._def) {
    return Ue.create(t, {
      ...this._def,
      ...r
    });
  }
  exclude(t, r = this._def) {
    return Ue.create(this.options.filter((n) => !t.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
Rt = /* @__PURE__ */ new WeakMap();
Ue.create = Ni;
class rr extends D {
  constructor() {
    super(...arguments), It.set(this, void 0);
  }
  _parse(t) {
    const r = W.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(t);
    if (n.parsedType !== _.string && n.parsedType !== _.number) {
      const a = W.objectValues(r);
      return b(n, {
        expected: W.joinValues(a),
        received: n.parsedType,
        code: g.invalid_type
      }), P;
    }
    if (Sr(this, It) || Oi(this, It, new Set(W.getValidEnumValues(this._def.values))), !Sr(this, It).has(t.data)) {
      const a = W.objectValues(r);
      return b(n, {
        received: n.data,
        code: g.invalid_enum_value,
        options: a
      }), P;
    }
    return fe(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
It = /* @__PURE__ */ new WeakMap();
rr.create = (e, t) => new rr({
  values: e,
  typeName: j.ZodNativeEnum,
  ...M(t)
});
class kt extends D {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== _.promise && r.common.async === !1)
      return b(r, {
        code: g.invalid_type,
        expected: _.promise,
        received: r.parsedType
      }), P;
    const n = r.parsedType === _.promise ? r.data : Promise.resolve(r.data);
    return fe(n.then((a) => this._def.type.parseAsync(a, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
kt.create = (e, t) => new kt({
  type: e,
  typeName: j.ZodPromise,
  ...M(t)
});
class Te extends D {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === j.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), a = this._def.effect || null, i = {
      addIssue: (o) => {
        b(n, o), o.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), a.type === "preprocess") {
      const o = a.transform(n.data, i);
      if (n.common.async)
        return Promise.resolve(o).then(async (s) => {
          if (r.value === "aborted")
            return P;
          const c = await this._def.schema._parseAsync({
            data: s,
            path: n.path,
            parent: n
          });
          return c.status === "aborted" ? P : c.status === "dirty" || r.value === "dirty" ? vt(c.value) : c;
        });
      {
        if (r.value === "aborted")
          return P;
        const s = this._def.schema._parseSync({
          data: o,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? P : s.status === "dirty" || r.value === "dirty" ? vt(s.value) : s;
      }
    }
    if (a.type === "refinement") {
      const o = (s) => {
        const c = a.refinement(s, i);
        if (n.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return s;
      };
      if (n.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? P : (s.status === "dirty" && r.dirty(), o(s.value), { status: r.value, value: s.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((s) => s.status === "aborted" ? P : (s.status === "dirty" && r.dirty(), o(s.value).then(() => ({ status: r.value, value: s.value }))));
    }
    if (a.type === "transform")
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!Ut(o))
          return o;
        const s = a.transform(o.value, i);
        if (s instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: s };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => Ut(o) ? Promise.resolve(a.transform(o.value, i)).then((s) => ({ status: r.value, value: s })) : o);
    W.assertNever(a);
  }
}
Te.create = (e, t, r) => new Te({
  schema: e,
  typeName: j.ZodEffects,
  effect: t,
  ...M(r)
});
Te.createWithPreprocess = (e, t, r) => new Te({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: j.ZodEffects,
  ...M(r)
});
class Oe extends D {
  _parse(t) {
    return this._getType(t) === _.undefined ? fe(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Oe.create = (e, t) => new Oe({
  innerType: e,
  typeName: j.ZodOptional,
  ...M(t)
});
class ze extends D {
  _parse(t) {
    return this._getType(t) === _.null ? fe(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ze.create = (e, t) => new ze({
  innerType: e,
  typeName: j.ZodNullable,
  ...M(t)
});
class nr extends D {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    let n = r.data;
    return r.parsedType === _.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
nr.create = (e, t) => new nr({
  innerType: e,
  typeName: j.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...M(t)
});
class ar extends D {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return zt(a) ? a.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new ge(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new ge(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
ar.create = (e, t) => new ar({
  innerType: e,
  typeName: j.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...M(t)
});
class Cr extends D {
  _parse(t) {
    if (this._getType(t) !== _.nan) {
      const n = this._getOrReturnCtx(t);
      return b(n, {
        code: g.invalid_type,
        expected: _.nan,
        received: n.parsedType
      }), P;
    }
    return { status: "valid", value: t.data };
  }
}
Cr.create = (e) => new Cr({
  typeName: j.ZodNaN,
  ...M(e)
});
const ld = Symbol("zod_brand");
class In extends D {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class sr extends D {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return i.status === "aborted" ? P : i.status === "dirty" ? (r.dirty(), vt(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return a.status === "aborted" ? P : a.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(t, r) {
    return new sr({
      in: t,
      out: r,
      typeName: j.ZodPipeline
    });
  }
}
class ir extends D {
  _parse(t) {
    const r = this._def.innerType._parse(t), n = (a) => (Ut(a) && (a.value = Object.freeze(a.value)), a);
    return zt(r) ? r.then((a) => n(a)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ir.create = (e, t) => new ir({
  innerType: e,
  typeName: j.ZodReadonly,
  ...M(t)
});
function $i(e, t = {}, r) {
  return e ? Tt.create().superRefine((n, a) => {
    var i, o;
    if (!e(n)) {
      const s = typeof t == "function" ? t(n) : typeof t == "string" ? { message: t } : t, c = (o = (i = s.fatal) !== null && i !== void 0 ? i : r) !== null && o !== void 0 ? o : !0, u = typeof s == "string" ? { message: s } : s;
      a.addIssue({ code: "custom", ...u, fatal: c });
    }
  }) : Tt.create();
}
const ud = {
  object: X.lazycreate
};
var j;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(j || (j = {}));
const dd = (e, t = {
  message: `Input not instance of ${e.name}`
}) => $i((r) => r instanceof e, t), Mi = _e.create, Ai = He.create, fd = Cr.create, hd = Ye.create, Di = Gt.create, md = at.create, pd = Or.create, gd = qt.create, vd = Xt.create, yd = Tt.create, bd = rt.create, xd = Ae.create, _d = jr.create, wd = we.create, Td = X.create, kd = X.strictCreate, Ed = Kt.create, Sd = Hr.create, Od = Jt.create, jd = Ne.create, Pd = Qt.create, Cd = Pr.create, Nd = it.create, $d = bt.create, Md = er.create, Ad = tr.create, Dd = Ue.create, Rd = rr.create, Id = kt.create, La = Te.create, Fd = Oe.create, Ld = ze.create, Wd = Te.createWithPreprocess, Zd = sr.create, Vd = () => Mi().optional(), Bd = () => Ai().optional(), Hd = () => Di().optional(), Yd = {
  string: (e) => _e.create({ ...e, coerce: !0 }),
  number: (e) => He.create({ ...e, coerce: !0 }),
  boolean: (e) => Gt.create({
    ...e,
    coerce: !0
  }),
  bigint: (e) => Ye.create({ ...e, coerce: !0 }),
  date: (e) => at.create({ ...e, coerce: !0 })
}, Ud = P;
var E = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: wt,
  setErrorMap: Uu,
  getErrorMap: kr,
  makeIssue: Er,
  EMPTY_PATH: zu,
  addIssueToContext: b,
  ParseStatus: le,
  INVALID: P,
  DIRTY: vt,
  OK: fe,
  isAborted: En,
  isDirty: Sn,
  isValid: Ut,
  isAsync: zt,
  get util() {
    return W;
  },
  get objectUtil() {
    return kn;
  },
  ZodParsedType: _,
  getParsedType: Ve,
  ZodType: D,
  datetimeRegex: Ci,
  ZodString: _e,
  ZodNumber: He,
  ZodBigInt: Ye,
  ZodBoolean: Gt,
  ZodDate: at,
  ZodSymbol: Or,
  ZodUndefined: qt,
  ZodNull: Xt,
  ZodAny: Tt,
  ZodUnknown: rt,
  ZodNever: Ae,
  ZodVoid: jr,
  ZodArray: we,
  ZodObject: X,
  ZodUnion: Kt,
  ZodDiscriminatedUnion: Hr,
  ZodIntersection: Jt,
  ZodTuple: Ne,
  ZodRecord: Qt,
  ZodMap: Pr,
  ZodSet: it,
  ZodFunction: bt,
  ZodLazy: er,
  ZodLiteral: tr,
  ZodEnum: Ue,
  ZodNativeEnum: rr,
  ZodPromise: kt,
  ZodEffects: Te,
  ZodTransformer: Te,
  ZodOptional: Oe,
  ZodNullable: ze,
  ZodDefault: nr,
  ZodCatch: ar,
  ZodNaN: Cr,
  BRAND: ld,
  ZodBranded: In,
  ZodPipeline: sr,
  ZodReadonly: ir,
  custom: $i,
  Schema: D,
  ZodSchema: D,
  late: ud,
  get ZodFirstPartyTypeKind() {
    return j;
  },
  coerce: Yd,
  any: yd,
  array: wd,
  bigint: hd,
  boolean: Di,
  date: md,
  discriminatedUnion: Sd,
  effect: La,
  enum: Dd,
  function: $d,
  instanceof: dd,
  intersection: Od,
  lazy: Md,
  literal: Ad,
  map: Cd,
  nan: fd,
  nativeEnum: Rd,
  never: xd,
  null: vd,
  nullable: Ld,
  number: Ai,
  object: Td,
  oboolean: Hd,
  onumber: Bd,
  optional: Fd,
  ostring: Vd,
  pipeline: Zd,
  preprocess: Wd,
  promise: Id,
  record: Pd,
  set: Nd,
  strictObject: kd,
  string: Mi,
  symbol: pd,
  transformer: La,
  tuple: jd,
  undefined: gd,
  union: Ed,
  unknown: bd,
  void: _d,
  NEVER: Ud,
  ZodIssueCode: g,
  quotelessJson: Yu,
  ZodError: ge
});
const zd = E.coerce.string();
var Nr = /* @__PURE__ */ ((e) => (e.ADHD = "ADHD", e.Anxiety = "Anxiety d/o", e.Autism = "Autism spectrum", e.GenderDysphoria = "Gender dysphoria", e.Trauma = "Trauma (including PTSD)", e.Depression = "Depressive d/o", e.BipolarSpectrum = "Bipolar spectrum", e.AngerManagement = "Anger management", e.OCD = "OCD", e.PersonalityDO = "Personality d/o", e.SubstanceUse = "Substance use", e.EatingDisorder = "Eating d/o", e.Psychosis = "Psychosis (e.g. schizophrenia)", e.DissociativeDO = "Dissociative d/o", e.DevelopmentalDelal = "Developmental delay", e.TraumaticBrainInjury = "Traumatic brain injury", e))(Nr || {});
const Gd = E.array(E.nativeEnum(Nr));
var $r = /* @__PURE__ */ ((e) => (e.Virtual = "virtual", e.InPerson = "in-person", e))($r || {});
const qd = E.nativeEnum($r);
var Mr = /* @__PURE__ */ ((e) => (e.Asian = "Asian", e.BlackOrAfricanAmerican = "Black or African American", e.HispanicOrLatinx = "Hispanic or Latinx", e.White = "White", e.Other = "Other", e))(Mr || {});
const Ri = E.union([E.nativeEnum(Mr), E.string(), E.undefined()]).transform((e) => {
  if (!(Br(e) || _t(e)))
    return e;
});
var Fn = /* @__PURE__ */ ((e) => (e.Male = "M", e.Female = "F", e.NonBinaryOrNonConforming = "Non-binary/non-conforming", e))(Fn || {});
const Ln = E.nativeEnum(Fn), Xd = E.string();
var $ = /* @__PURE__ */ ((e) => (e.CherryCreek = "CO - Cherry Creek", e.GreenwoodVillage = "CO - Greenwood Village", e.CentralPark = "CO - Central Park", e.Lakewood = "CO - Lakewood", e.Boulder = "CO - Boulder", e.HighlandsRanch = "CO - Highlands Ranch", e.Broomfield = "CO - Broomfield", e.Parker = "CO - Parker", e.Gaithersburg = "MD - Gaithersburg", e.Frederick = "MD - Frederick", e.Ballston = "MD - Ballston", e.Downtown = "MD - Downtown", e.Tysons = "MD - Tysons", e.SilverSpring = "MD - Silver Spring", e.BrooklynHeights = "NY - Brooklyn Heights", e.UnionSquare = "NY - Union Square", e.LongIslandCity = "NY - Long Island City", e.ColumbusCircle = "NY - Columbus Circle", e.Williamsburg = "NY - Williamsburg", e.WallStreet = "NY - Wall Street", e.Astoria = "NY - Astoria", e.Gowanus = "NY - Gowanus", e.MidtownEast = "NY - Midtown East", e.Manhasset = "NY - Manhasset", e.Melville = "NY - Melville", e.ValleyStream = "NY - Valley Stream", e.Massapequa = "NY - Massapequa", e.Woodlands = "TX - Woodlands", e.UpperKirby = "TX - Upper Kirby", e.Austin = "TX - Austin", e))($ || {});
const Kd = E.nativeEnum($);
var or = /* @__PURE__ */ ((e) => (e.CO = "CO", e.NY = "NY", e.TX = "TX", e.VA = "VA", e.MD = "MD", e.DC = "DC", e))(or || {});
const Jd = {
  CO: "Colorado",
  NY: "New York",
  TX: "Texas",
  VA: "Virginia",
  MD: "Maryland",
  DC: "Washington DC"
}, Wn = E.nativeEnum(or);
var Ii = /* @__PURE__ */ ((e) => (e.Psychiatric = "Psychiatric", e.Therapy = "Therapy", e))(Ii || {});
const Qd = E.nativeEnum(Ii), Wa = E.coerce.date(), Zn = E.object({
  errorMessage: E.string().optional(),
  errorCode: E.string().optional()
});
var Vn = /* @__PURE__ */ ((e) => (e.VirtualOnly = "virtual only", e.Both = "both", e))(Vn || {});
const ef = E.nativeEnum(Vn), _p = E.object({
  providerId: E.array(E.string())
}), Fi = E.object({
  eventId: E.string(),
  date: Wa,
  providerId: E.string(),
  slotstart: Wa,
  duration: E.number(),
  facility: E.string(),
  location: ef.optional()
}), wp = E.object({
  data: E.record(E.string(), E.array(Fi))
}).merge(Zn), Li = E.object({
  age: zd.optional(),
  gender: Ln.optional(),
  ethnicity: Ri.optional(),
  // Not implemented
  language: Xd.optional(),
  therapeuticModality: Qd.optional(),
  clinicalFocus: Gd.optional(),
  deliveryMethod: qd.optional(),
  location: E.object({
    facility: Kd.optional(),
    state: Wn.optional()
  }).optional()
}), Tp = E.object({
  data: E.array(
    E.object({
      gender: Ln.optional(),
      ethnicity: Ri.optional(),
      // Not implemented
      // language: z.string().optional(),
      location: E.object({
        // Not implemented
        facility: E.string().optional(),
        state: Wn.optional()
      }).optional(),
      name: E.string(),
      id: E.string(),
      // Data warehouse ID
      clinicalFocus: E.array(E.string()).optional(),
      bio: E.string().optional(),
      image: E.string().optional(),
      profileLink: E.string().optional(),
      events: E.array(Fi).optional().transform((e) => Br(e) || e.length === 0 ? [] : e)
    })
  )
}).merge(Zn), kp = E.object({
  eventId: E.string(),
  providerId: E.string(),
  userInfo: E.object({
    userName: E.string()
  }),
  locationType: E.string()
}), Ep = E.object({
  data: E.unknown()
}).merge(Zn), tf = {
  CO: "Colorado",
  NY: "New York",
  TX: "Texas",
  VA: "Virginia",
  MD: "Maryland",
  DC: "District of Columbia"
}, rf = (e) => {
  try {
    const t = Wn.parse(e);
    return tf[t];
  } catch {
    return e;
  }
}, nf = {
  M: "Male",
  F: "Female",
  "Non-binary/non-conforming": "Non-binary/non-conforming"
}, af = (e) => {
  try {
    const t = Ln.parse(e);
    return nf[t];
  } catch {
    return e;
  }
}, Bn = ({
  name: e,
  image: t,
  classes: r = "w-16 h-16"
}) => {
  const n = e.split(" ").map((a) => a[0]).join("");
  return /* @__PURE__ */ f.jsx("div", { className: "avatar", children: /* @__PURE__ */ f.jsx("div", { className: I(`rounded-full ${r} bg-slate-600`), children: t ? /* @__PURE__ */ f.jsx("img", { alt: e, src: t }) : /* @__PURE__ */ f.jsx("span", { className: "text-center text-white font-bold h-full flex items-center justify-center w-full", children: n }) }) });
}, sf = ({
  provider: e,
  onSelect: t,
  text: r
}) => {
  var s, c;
  const { button: n = "Book appointment" } = r || {}, a = ((s = e.location) == null ? void 0 : s.state) ?? "", i = ki(((e == null ? void 0 : e.events) ?? []).map((u) => u.facility)), o = e.profileLink ?? "";
  return /* @__PURE__ */ f.jsxs("div", { className: "rounded-md border-1 bg-white p-4", children: [
    /* @__PURE__ */ f.jsxs("div", { className: "flex gap-4 align-center justify-between", children: [
      /* @__PURE__ */ f.jsxs("div", { className: "flex gap-4 align-center", children: [
        /* @__PURE__ */ f.jsx(Bn, { name: e.name, image: e.image }),
        /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col justify-center", children: [
          /* @__PURE__ */ f.jsx("h3", { className: "text-slate-800 text-lg m-0 font-semibold", children: e.name }),
          /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col sm:flex-row sm:items-center", children: [
            a.length > 0 && /* @__PURE__ */ f.jsx("span", { className: "text-slate-600 text-md", children: rf(a) }),
            a.length > 0 && o.length > 0 && /* @__PURE__ */ f.jsx("span", { className: "text-slate-600 text-md hidden sm:inline px-1", children: "•" }),
            o.length > 0 && /* @__PURE__ */ f.jsx(cf, { link: o })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ f.jsx("div", { className: "flex", children: /* @__PURE__ */ f.jsx(lf, { count: ((c = e.events) == null ? void 0 : c.length) ?? 0 }) })
    ] }),
    /* @__PURE__ */ f.jsxs("div", { className: I("mt-4 bg-slate-100 rounded-md p-3"), children: [
      /* @__PURE__ */ f.jsxs("div", { children: [
        /* @__PURE__ */ f.jsxs("ul", { className: "flex flex-wrap list-none m-0 p-0 gap-y-4 mb-4", children: [
          e.gender && /* @__PURE__ */ f.jsx(
            ln,
            {
              label: "Gender",
              value: af(e.gender)
            }
          ),
          e.ethnicity && /* @__PURE__ */ f.jsx(ln, { label: "Ethnicity", value: e.ethnicity })
        ] }),
        /* @__PURE__ */ f.jsxs("ul", { className: "flex flex-wrap list-none m-0 p-0 gap-y-4 mb-4", children: [
          i.length > 0 && /* @__PURE__ */ f.jsx(
            ln,
            {
              label: `Clinic Location${i.length > 1 ? "s" : ""}`,
              value: i.join(", ")
            }
          ),
          e.bio && /* @__PURE__ */ f.jsx(of, { label: "Bio", value: e.bio })
        ] })
      ] }),
      /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx(
        "button",
        {
          onClick: () => t(e.id),
          className: I("btn btn-primary w-full"),
          children: n
        }
      ) })
    ] })
  ] }, e.id);
}, ln = ({ label: e, value: t }) => /* @__PURE__ */ f.jsxs("li", { className: "flex-1 basis-1/2", children: [
  /* @__PURE__ */ f.jsxs("span", { className: "font-semibold text-primary", children: [
    e,
    ": "
  ] }),
  /* @__PURE__ */ f.jsx("span", { children: t })
] }), of = ({ label: e, value: t }) => {
  const [r, n] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), a = () => {
    n(!r);
  }, i = "text-blue-500 rounded-full text-sm text-blue font-medium flex items-center justify-center";
  return /* @__PURE__ */ f.jsxs("li", { className: "flex-1 basis-full", children: [
    /* @__PURE__ */ f.jsxs("span", { className: "font-semibold text-primary", children: [
      e,
      ": "
    ] }),
    r ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      /* @__PURE__ */ f.jsx("span", { children: t }),
      /* @__PURE__ */ f.jsx("button", { onClick: a, className: i, children: " < Hide" })
    ] }) : /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      /* @__PURE__ */ f.jsxs("span", { children: [
        t.substring(0, 120),
        "..."
      ] }),
      /* @__PURE__ */ f.jsx("button", { onClick: a, className: i, children: " > Show more" })
    ] })
  ] });
}, cf = ({ link: e }) => /* @__PURE__ */ f.jsx(
  "a",
  {
    href: e,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "link text-blue-500 no-underline hover:underline",
    "aria-label": "Visit provider profile page",
    children: "View Profile"
  }
), lf = ({ count: e }) => {
  const t = e === 1 ? "slot" : "slots";
  return /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx(
    "div",
    {
      className: I(
        "rounded-full text-sm text-white text-center font-medium my-2 flex items-center justify-center px-3 py-1",
        {
          "bg-slate-300": e === 0,
          "bg-yellow-500": e > 0 && e <= 2,
          "bg-green-600": e > 2
        }
      ),
      "aria-hidden": "true",
      children: e === 0 ? "No slots" : `${e} ${t} available`
    }
  ) });
}, uf = {
  "scrollable-container": "_scrollable-container_ztccy_2"
}, df = ({ onChange: e }) => {
  const { getActiveFilter: t, setActiveFilter: r } = Se(), n = t(), a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    a !== null && a.current !== null && a.current.focus();
  }, [a]), /* @__PURE__ */ f.jsxs("div", { className: "flex justify-between items-center mb-2 mx-4", children: [
    /* @__PURE__ */ f.jsx(
      "input",
      {
        type: "text",
        placeholder: `Filter by ${n.label}`,
        className: "input w-48 md:w-72 h-8 text-sm focus:outline-0 rounded-md focus:border-primary focus:border-1",
        onChange: (i) => e(i.target.value),
        ref: a
      }
    ),
    /* @__PURE__ */ f.jsx(
      "button",
      {
        className: "btn border-0 btn-circle shadow-none",
        onClick: () => r(null),
        children: /* @__PURE__ */ f.jsx(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            className: "h-6 w-6",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor",
            children: /* @__PURE__ */ f.jsx(
              "path",
              {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                d: "M6 18L18 6M6 6l12 12"
              }
            )
          }
        )
      }
    )
  ] });
}, un = ({ value: e, label: t }) => {
  const { getActiveFilter: r, updateFilter: n, setActiveFilter: a } = Se(), i = r(), o = (s) => {
    i.selectType === "single" ? (i.selectedOptions[0] === s ? n({
      ...i,
      selectedOptions: []
    }) : n({
      ...i,
      selectedOptions: [s]
    }), i.key === "location" && s && s.length > 2 && a(null)) : n({
      ...i,
      selectedOptions: i.selectedOptions.includes(s) ? i.selectedOptions.filter((c) => c !== s) : [...i.selectedOptions, s]
    });
  };
  return /* @__PURE__ */ f.jsx(
    "button",
    {
      className: I(
        "btn btn-sm text-sm border-1 border-primary font-medium",
        {
          "bg-primary text-primary-content": i.selectedOptions.includes(e),
          "bg-primary-content text-primary": !i.selectedOptions.includes(e)
        }
      ),
      onClick: (s) => {
        s.preventDefault(), o(e);
      },
      children: t
    },
    e
  );
}, ff = {
  CO: [
    $.CherryCreek,
    $.GreenwoodVillage,
    $.CentralPark,
    $.Lakewood,
    $.Boulder,
    $.HighlandsRanch,
    $.Broomfield,
    $.Parker
  ],
  MD: [
    $.Gaithersburg,
    $.Frederick,
    $.Ballston,
    $.Downtown,
    $.Tysons,
    $.SilverSpring
  ],
  NY: [
    $.BrooklynHeights,
    $.UnionSquare,
    $.LongIslandCity,
    $.ColumbusCircle,
    $.Williamsburg,
    $.WallStreet,
    $.Astoria,
    $.Gowanus,
    $.MidtownEast,
    $.Manhasset,
    $.Melville,
    $.ValleyStream,
    $.Massapequa
  ],
  TX: [
    $.Woodlands,
    $.UpperKirby,
    $.Austin
  ],
  VA: [
    $.Gaithersburg,
    $.Frederick,
    $.Ballston,
    $.Downtown,
    $.Tysons,
    $.SilverSpring
  ],
  DC: [
    $.Gaithersburg,
    $.Frederick,
    $.Ballston,
    $.Downtown,
    $.Tysons,
    $.SilverSpring
  ]
}, hf = (e) => {
  const { className: t } = e, { getActiveFilter: r } = Se(), n = r(), a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => n.key === "location", [n]), [i, o] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(n.options), [s, c] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({ states: [], facilities: [] });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (a) {
      const d = i.filter(
        (v) => v.value.length === 2
      ), h = i.filter(
        (v) => v.value.length > 2
      );
      if (!_t(n.selectedOptions[0]) && n.selectedOptions[0].length === 2) {
        const v = n.selectedOptions[0], m = ff[v].map((y) => ({ label: y, value: y }));
        c({ states: d, facilities: m });
      } else
        c({ states: d, facilities: h });
    } else
      c({ states: [], facilities: [] });
  }, [n, i]);
  const u = (d) => {
    const h = n.options.filter(
      (v) => String(v.label).toLowerCase().includes(d.toLowerCase()) || String(v.value).toLowerCase().includes(d.toLowerCase())
    );
    o(h);
  };
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(df, { onChange: u }),
    !a && /* @__PURE__ */ f.jsx(
      "div",
      {
        className: I("flex w-full gap-2 px-4 flex-wrap z-20", t),
        children: i.map(({ label: d, value: h }) => /* @__PURE__ */ f.jsx(un, { label: d, value: h }, h))
      }
    ),
    a && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      /* @__PURE__ */ f.jsx("div", { className: "w-full mt-2 mb-1 z-20 font-semibold text-md flex", children: "States" }),
      /* @__PURE__ */ f.jsx(
        "div",
        {
          className: I("flex w-full gap-2 px-4 flex-wrap z-20", t),
          children: s.states.map(({ label: d, value: h }) => /* @__PURE__ */ f.jsx(un, { label: d, value: h }, h))
        }
      ),
      /* @__PURE__ */ f.jsx("div", { className: "w-full mt-2 mb-1 z-20 font-semibold text-md flex", children: "Facilities" }),
      /* @__PURE__ */ f.jsx(
        "div",
        {
          className: I("flex w-full gap-2 px-4 flex-wrap z-20", t),
          children: s.facilities.map(({ label: d, value: h }) => /* @__PURE__ */ f.jsx(un, { label: d, value: h }, h))
        }
      )
    ] })
  ] });
};
function mf(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  e && e.addEventListener && e.addEventListener.apply(e, t);
}
function pf(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  e && e.removeEventListener && e.removeEventListener.apply(e, t);
}
var gf = ["mousedown", "touchstart"], vf = function(e, t, r) {
  r === void 0 && (r = gf);
  var n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
    n.current = t;
  }, [t]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
    for (var a = function(c) {
      var u = e.current;
      u && !u.contains(c.target) && n.current(c);
    }, i = 0, o = r; i < o.length; i++) {
      var s = o[i];
      mf(document, s, a);
    }
    return function() {
      for (var c = 0, u = r; c < u.length; c++) {
        var d = u[c];
        pf(document, d, a);
      }
    };
  }, [r, e]);
};
const yf = ({ children: e }) => {
  const { activeFilter: t, setActiveFilter: r } = Se(), n = t !== null, a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  return vf(a, () => {
    r(null);
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => (n ? document.body.classList.add("overflow-hidden") : document.body.classList.remove("overflow-hidden"), () => {
    document.body.classList.remove("overflow-hidden");
  }), [n]), /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(
      "div",
      {
        className: I(
          "fixed inset-0 transition-transform duration-500 ease-in-out z-40",
          {
            "bg-opacity-30 bg-black": n,
            "bg-opacity-0 hidden bg-transparent": !n
          }
        )
      }
    ),
    /* @__PURE__ */ f.jsx(
      "div",
      {
        ref: a,
        className: I(
          "fixed top-0 left-1/2 transform -translate-x-1/2 max-w-[650px] w-full bg-slate-200 rounded-b-md text-slate-800 transition-transform duration-500 ease-in-out z-50 p-4",
          {
            "translate-y-0 p-4": n,
            "-translate-y-full p-0": !n,
            "overflow-y-auto max-h-screen": !0
          }
        ),
        children: t !== null && /* @__PURE__ */ f.jsx("div", { className: "mt-2", children: e })
      }
    )
  ] });
}, bf = (e) => e === "F" ? "Female" : e === "M" ? "Male" : e, xf = (e) => _t(e.selectedOptions) ? "" : e.selectedOptions.map((t) => bf(t)).join(", "), Wi = ({ filter: e }) => {
  const { setActiveFilter: t, updateFilter: r } = Se(), n = e.selectedOptions && e.selectedOptions.length > 0, a = `${e.label}${n ? ": " : ""}`;
  return /* @__PURE__ */ f.jsxs(
    "button",
    {
      className: I("btn btn-sm text-sm border-0 gap-1", {
        "bg-secondary text-slate-800 font-medium": n,
        "bg-slate-300 font-normal": !n
      }),
      onClick: (i) => {
        i.preventDefault(), t(e.key);
      },
      children: [
        a,
        n && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          /* @__PURE__ */ f.jsx(
            "span",
            {
              className: I({
                "truncate max-w-[250px]": e.selectType === "multi"
              }),
              children: xf(e)
            }
          ),
          /* @__PURE__ */ f.jsx(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24",
              className: "inline-block h-4 w-4 stroke-current cursor-pointer ml-2 -mr-2",
              onClick: (i) => {
                i.stopPropagation();
                const o = {
                  ...e,
                  selectedOptions: []
                };
                r(o);
              },
              children: /* @__PURE__ */ f.jsx(
                "path",
                {
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: "2",
                  d: "M6 18L18 6M6 6l12 12"
                }
              )
            }
          )
        ] })
      ]
    },
    e.key
  );
};
Wi.displayName = "FilterBadge";
const _f = ({ filters: e }) => /* @__PURE__ */ f.jsx(f.Fragment, { children: e.map((t) => /* @__PURE__ */ f.jsx(Wi, { filter: t }, t.key)) }), Zi = () => {
  const { filters: e } = Se();
  return /* @__PURE__ */ f.jsxs("div", { className: "overflow-x-hidden mb-2", children: [
    /* @__PURE__ */ f.jsx(yf, { children: /* @__PURE__ */ f.jsx(hf, {}) }),
    /* @__PURE__ */ f.jsx(
      "div",
      {
        className: I(
          "overflow-x-auto pb-2 flex gap-2 whitespace-nowrap scroll z-10 md:flex-wrap",
          uf["scrollable-container"]
        ),
        children: /* @__PURE__ */ f.jsx(_f, { filters: e })
      }
    )
  ] });
};
Zi.displayName = "ProviderFilter";
const wf = ({
  text: e,
  onSelectProvider: t
}) => {
  const { providers: r, loading: n, setSelectedProviderId: a } = Se(), i = r.length === 1 ? "provider" : "providers", o = (s) => {
    a(s), t(s);
  };
  return /* @__PURE__ */ f.jsxs("div", { children: [
    /* @__PURE__ */ f.jsx(Zi, {}),
    n ? /* @__PURE__ */ f.jsx("div", { className: "h-full w-full flex items-center justify-center ", children: /* @__PURE__ */ f.jsx("span", { className: "loading loading-infinity loading-lg" }) }) : /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      /* @__PURE__ */ f.jsxs("h2", { className: I("text-slate-800 text-2xl font-semibold mb-4"), children: [
        "We found",
        " ",
        /* @__PURE__ */ f.jsxs("span", { className: "text-primary", children: [
          r.length,
          " ",
          i
        ] }),
        " ",
        "for you"
      ] }),
      /* @__PURE__ */ f.jsx("div", { className: "flex flex-col gap-4", children: r.map((s) => /* @__PURE__ */ f.jsx(
        sf,
        {
          provider: s,
          onSelect: o,
          text: e
        },
        s.id
      )) })
    ] })
  ] });
};
function Tf(e) {
  return e != null && typeof e == "object" && "key" in e && "options" in e;
}
const dn = (e) => Object.entries(e).map(([t, r]) => ({
  label: xi(r),
  value: r
})), kf = () => {
  const e = Object.entries(or).map(([r, n]) => ({
    label: Jd[r],
    value: n
  })), t = Object.entries($).map(([r, n]) => ({
    label: n,
    value: n
  }));
  return [...e, ...t];
}, Ef = () => [
  {
    label: "Male",
    value: "M"
  },
  {
    label: "Female",
    value: "F"
  },
  {
    label: "Non-binary/non-conforming",
    value: "Non-binary/non-conforming"
  }
], Sf = (e, t) => {
  t.forEach((n) => {
    switch (n.key) {
      case "age":
      case "therapeuticModality":
      case "language":
        return;
      case "location": {
        e.location && n.selectedOptions.length > 0 && (n.selectedOptions[0].length === 2 ? (n.selectedOptions[0] === "DC" || n.selectedOptions[0] === "VA" ? e.location.state = or.MD : e.location.state = n.selectedOptions[0], e.location.facility = void 0) : (e.location.state = void 0, e.location.facility = n.selectedOptions[0]));
        break;
      }
      case "gender": {
        e.gender = n.selectedOptions[0];
        break;
      }
      case "ethnicity": {
        e.ethnicity = n.selectedOptions[0];
        break;
      }
      case "clinicalFocus": {
        e.clinicalFocus = n.selectedOptions;
        break;
      }
      case "deliveryMethod":
        e.deliveryMethod = n.selectedOptions[0];
    }
  });
  const r = Li.safeParse(e);
  return console.log("parsed prefs from filters", r.data), r.success ? r.data : (console.error("Error updating preferences with filters", {
    parsed: r,
    prefs: e,
    filters: t
  }), e);
}, Of = (e) => Object.keys(Li.shape).map((t) => {
  var r, n;
  switch (t) {
    case "age":
      return;
    case "gender":
      return {
        key: "gender",
        label: "Gender",
        selectType: "single",
        filterType: "simple",
        enum: Fn,
        options: Ef(),
        selectedOptions: e[t] ? [e[t]] : []
      };
    case "ethnicity":
      return {
        key: "ethnicity",
        label: "Ethnicity",
        selectType: "single",
        filterType: "simple",
        enum: Mr,
        options: dn(Mr),
        selectedOptions: e[t] ? [e[t]] : []
      };
    case "language":
      return;
    case "clinicalFocus":
      return {
        key: "clinicalFocus",
        label: "Clinical Focus",
        selectType: "multi",
        filterType: "simple",
        enum: Nr,
        options: dn(Nr),
        selectedOptions: e[t] ? e[t] : []
      };
    case "deliveryMethod":
      return {
        key: "deliveryMethod",
        label: "Delivery Method",
        selectType: "single",
        filterType: "simple",
        enum: $r,
        options: dn($r),
        selectedOptions: []
      };
    case "location":
      return {
        key: "location",
        label: "Location",
        selectType: "single",
        filterType: "compound",
        enum: { facility: $, state: or },
        options: kf(),
        selectedOptions: (r = e.location) != null && r.state ? [e.location.state] : (n = e.location) != null && n.facility ? [e.location.facility] : []
      };
    default:
      return;
  }
}).filter((t) => Tf(t)), Vi = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null), jf = ({
  children: e,
  fetchAvailability: t,
  fetchProviders: r,
  bookAppointment: n,
  completeActivity: a
}) => {
  const [i, o] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(
    []
  ), s = (C) => {
    u(!0), r(C).then((S) => {
      o(S.data);
    }).finally(() => u(!1));
  }, [c, u] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), [d, h] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), v = (C) => {
    y(!0), t(C).then((S) => {
      h(S.data[C]), console.log(
        `set availabilities for provider id ${C}`,
        S.data[C]
      );
    }).finally(() => y(!1));
  }, [m, y] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), O = {
    providers: {
      data: i,
      fetch: s,
      loading: c
    },
    availabilities: {
      data: d,
      fetch: v,
      loading: m
    },
    bookAppointment: (C, S, J) => {
      n(C).then((U) => {
        console.log("Booked appointment", U), a(C, S);
      }).catch(() => {
        console.error("Error booking appointment"), J();
      });
    }
  };
  return /* @__PURE__ */ f.jsx(Vi.Provider, { value: O, children: e });
}, Hn = () => {
  const e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Vi);
  if (!e)
    throw new Error("useSolApi must be used within SolApiProvider");
  return e;
}, Bi = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(
  null
), Pf = ({
  children: e,
  initialPreferences: t
}) => {
  const [r, n] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(
    Of(t)
  ), [a, i] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), [o, s] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(t), [c, u] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(void 0), [d, h] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(
    void 0
  ), [v, m] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({ preferences: t }), {
    providers: { fetch: y, data: w, loading: O }
  } = Hn(), C = $u((k) => {
    const Q = Sf(
      t,
      k
    );
    s(Q);
  }, 500), S = (k) => {
    const Q = r.map((pe) => pe.key === k.key ? k : pe);
    n(Q), C(Q);
  }, J = (k) => {
    k === null || k === a ? i(null) : k !== null && i(k);
  }, U = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => r.find(
    (k) => k.key === a
  ), [r, a]), ae = (k) => {
    u(w.find((Q) => Q.id === k));
  }, F = (k) => {
    m({
      ...v,
      deliveryMethod: k
    });
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    y(o);
  }, [o]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    m({
      provider: c,
      slot: d,
      preferences: o
    });
  }, [d, c, o]);
  const z = {
    filters: r,
    setFilters: C,
    updateFilter: S,
    activeFilter: a,
    setActiveFilter: J,
    getActiveFilter: U,
    providers: w,
    selectedProvider: c,
    setSelectedProviderId: ae,
    setSelectedSlot: h,
    setDeliveryMethod: F,
    bookingInformation: v,
    loading: O
  };
  return /* @__PURE__ */ f.jsx(Bi.Provider, { value: z, children: e });
}, Se = () => {
  const e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Bi);
  if (!e)
    throw new Error(
      "useProviderFilter must be used within a ProviderFilterProvider"
    );
  return e;
}, Cf = ({ otherBookingData: e }) => {
  const t = "Something went wrong when trying to schedule your appointment.", { bookingInformation: r } = Se(), { provider: n, slot: a } = r;
  return /* @__PURE__ */ f.jsxs("div", { children: [
    /* @__PURE__ */ f.jsx("p", { className: I("font-medium text-xl text-center m-0"), children: t }),
    /* @__PURE__ */ f.jsx("div", { className: I("card bg-base-100 shadow-md"), children: /* @__PURE__ */ f.jsxs("div", { className: "card-body flex", children: [
      /* @__PURE__ */ f.jsxs("div", { className: I("card-title justify-between"), children: [
        /* @__PURE__ */ f.jsxs("div", { className: I("flex flex-col"), children: [
          /* @__PURE__ */ f.jsx("p", { className: "font-normal text-lg", children: "You tried to schedule with" }),
          /* @__PURE__ */ f.jsx("p", { className: "font-semibold text-lg", children: (n == null ? void 0 : n.name) ?? "Unknown" })
        ] }),
        /* @__PURE__ */ f.jsx(
          Bn,
          {
            name: (n == null ? void 0 : n.name) ?? "",
            image: n == null ? void 0 : n.image
          }
        )
      ] }),
      /* @__PURE__ */ f.jsxs("ul", { className: I("list-none p-0 m-0"), children: [
        /* @__PURE__ */ f.jsxs(Ze, { children: [
          /* @__PURE__ */ f.jsx(Ze.Header, { children: "Time: " }),
          /* @__PURE__ */ f.jsx(
            "time",
            {
              className: I("block"),
              dateTime: (a == null ? void 0 : a.slotstart.toISOString()) ?? "Unknown",
              children: (a == null ? void 0 : a.slotstart.toLocaleString()) ?? "Unknown"
            }
          )
        ] }),
        (a == null ? void 0 : a.duration) && /* @__PURE__ */ f.jsxs(Ze, { children: [
          /* @__PURE__ */ f.jsx(Ze.Header, { children: "Duration: " }),
          /* @__PURE__ */ f.jsxs("div", { children: [
            a == null ? void 0 : a.duration,
            " minutes"
          ] })
        ] }),
        e && Object.entries(e).map(([i, o]) => /* @__PURE__ */ f.jsxs(Ze, { children: [
          /* @__PURE__ */ f.jsxs(Ze.Header, { children: [
            xi(i),
            ": "
          ] }),
          /* @__PURE__ */ f.jsx("div", { children: String(o) })
        ] }, i))
      ] }),
      /* @__PURE__ */ f.jsx("p", { className: I("font-medium text-xl text-center m-0"), children: "Please go back and try again." })
    ] }) })
  ] });
}, Ze = ({ children: e }) => /* @__PURE__ */ f.jsx("li", { className: I("py-4 border-t-slate-200 border-t"), children: e });
Ze.Header = ({ children: e }) => /* @__PURE__ */ f.jsx("div", { className: I("font-bold"), children: e });
Ze.Header.displayName = "ListItemHeader";
function ne(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function De(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Nf(e, t) {
  const r = ne(e);
  return isNaN(t) ? De(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
const Hi = 6048e5, $f = 864e5;
let Mf = {};
function cr() {
  return Mf;
}
function Et(e, t) {
  var s, c, u, d;
  const r = cr(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) ?? r.weekStartsOn ?? ((d = (u = r.locale) == null ? void 0 : u.options) == null ? void 0 : d.weekStartsOn) ?? 0, a = ne(e), i = a.getDay(), o = (i < n ? 7 : 0) + i - n;
  return a.setDate(a.getDate() - o), a.setHours(0, 0, 0, 0), a;
}
function Ar(e) {
  return Et(e, { weekStartsOn: 1 });
}
function Yi(e) {
  const t = ne(e), r = t.getFullYear(), n = De(e, 0);
  n.setFullYear(r + 1, 0, 4), n.setHours(0, 0, 0, 0);
  const a = Ar(n), i = De(e, 0);
  i.setFullYear(r, 0, 4), i.setHours(0, 0, 0, 0);
  const o = Ar(i);
  return t.getTime() >= a.getTime() ? r + 1 : t.getTime() >= o.getTime() ? r : r - 1;
}
function Dr(e) {
  const t = ne(e);
  return t.setHours(0, 0, 0, 0), t;
}
function Za(e) {
  const t = ne(e), r = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return r.setUTCFullYear(t.getFullYear()), +e - +r;
}
function Ui(e, t) {
  const r = Dr(e), n = Dr(t), a = +r - Za(r), i = +n - Za(n);
  return Math.round((a - i) / $f);
}
function Af(e) {
  const t = Yi(e), r = De(e, 0);
  return r.setFullYear(t, 0, 4), r.setHours(0, 0, 0, 0), Ar(r);
}
function zi(e, t) {
  const r = t * 7;
  return Nf(e, r);
}
function Df(e) {
  return De(e, Date.now());
}
function Zt(e, t) {
  const r = Dr(e), n = Dr(t);
  return +r == +n;
}
function Rf(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function If(e) {
  if (!Rf(e) && typeof e != "number")
    return !1;
  const t = ne(e);
  return !isNaN(Number(t));
}
function Va(e, t) {
  const r = ne(e), n = ne(t), a = Ba(r, n), i = Math.abs(Ui(r, n));
  r.setDate(r.getDate() - a * i);
  const o = +(Ba(r, n) === -a), s = a * (i - o);
  return s === 0 ? 0 : s;
}
function Ba(e, t) {
  const r = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return r < 0 ? -1 : r > 0 ? 1 : r;
}
function Ff(e, t) {
  const r = ne(e.start), n = ne(e.end);
  let a = +r > +n;
  const i = a ? +r : +n, o = a ? n : r;
  o.setHours(0, 0, 0, 0);
  let s = 1;
  const c = [];
  for (; +o <= i; )
    c.push(ne(o)), o.setDate(o.getDate() + s), o.setHours(0, 0, 0, 0);
  return a ? c.reverse() : c;
}
function Lf(e) {
  const t = ne(e), r = De(e, 0);
  return r.setFullYear(t.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
function Wf(e, t) {
  var s, c, u, d;
  const r = cr(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) ?? r.weekStartsOn ?? ((d = (u = r.locale) == null ? void 0 : u.options) == null ? void 0 : d.weekStartsOn) ?? 0, a = ne(e), i = a.getDay(), o = (i < n ? -7 : 0) + 6 - (i - n);
  return a.setDate(a.getDate() + o), a.setHours(23, 59, 59, 999), a;
}
const Zf = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Vf = (e, t, r) => {
  let n;
  const a = Zf[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
};
function fn(e) {
  return (t = {}) => {
    const r = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[r] || e.formats[e.defaultWidth];
  };
}
const Bf = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Hf = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Yf = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Uf = {
  date: fn({
    formats: Bf,
    defaultWidth: "full"
  }),
  time: fn({
    formats: Hf,
    defaultWidth: "full"
  }),
  dateTime: fn({
    formats: Yf,
    defaultWidth: "full"
  })
}, zf = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Gf = (e, t, r, n) => zf[e];
function At(e) {
  return (t, r) => {
    const n = r != null && r.context ? String(r.context) : "standalone";
    let a;
    if (n === "formatting" && e.formattingValues) {
      const o = e.defaultFormattingWidth || e.defaultWidth, s = r != null && r.width ? String(r.width) : o;
      a = e.formattingValues[s] || e.formattingValues[o];
    } else {
      const o = e.defaultWidth, s = r != null && r.width ? String(r.width) : e.defaultWidth;
      a = e.values[s] || e.values[o];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[i];
  };
}
const qf = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Xf = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Kf = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Jf = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Qf = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, eh = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, th = (e, t) => {
  const r = Number(e), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, rh = {
  ordinalNumber: th,
  era: At({
    values: qf,
    defaultWidth: "wide"
  }),
  quarter: At({
    values: Xf,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: At({
    values: Kf,
    defaultWidth: "wide"
  }),
  day: At({
    values: Jf,
    defaultWidth: "wide"
  }),
  dayPeriod: At({
    values: Qf,
    defaultWidth: "wide",
    formattingValues: eh,
    defaultFormattingWidth: "wide"
  })
};
function Dt(e) {
  return (t, r = {}) => {
    const n = r.width, a = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], i = t.match(a);
    if (!i)
      return null;
    const o = i[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? ah(s, (h) => h.test(o)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      nh(s, (h) => h.test(o))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(c) : c, u = r.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      r.valueCallback(u)
    ) : u;
    const d = t.slice(o.length);
    return { value: u, rest: d };
  };
}
function nh(e, t) {
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r) && t(e[r]))
      return r;
}
function ah(e, t) {
  for (let r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function ih(e) {
  return (t, r = {}) => {
    const n = t.match(e.matchPattern);
    if (!n) return null;
    const a = n[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = r.valueCallback ? r.valueCallback(o) : o;
    const s = t.slice(a.length);
    return { value: o, rest: s };
  };
}
const sh = /^(\d+)(th|st|nd|rd)?/i, oh = /\d+/i, ch = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, lh = {
  any: [/^b/i, /^(a|c)/i]
}, uh = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, dh = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, fh = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, hh = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, mh = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, ph = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, gh = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, vh = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, yh = {
  ordinalNumber: ih({
    matchPattern: sh,
    parsePattern: oh,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Dt({
    matchPatterns: ch,
    defaultMatchWidth: "wide",
    parsePatterns: lh,
    defaultParseWidth: "any"
  }),
  quarter: Dt({
    matchPatterns: uh,
    defaultMatchWidth: "wide",
    parsePatterns: dh,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Dt({
    matchPatterns: fh,
    defaultMatchWidth: "wide",
    parsePatterns: hh,
    defaultParseWidth: "any"
  }),
  day: Dt({
    matchPatterns: mh,
    defaultMatchWidth: "wide",
    parsePatterns: ph,
    defaultParseWidth: "any"
  }),
  dayPeriod: Dt({
    matchPatterns: gh,
    defaultMatchWidth: "any",
    parsePatterns: vh,
    defaultParseWidth: "any"
  })
}, bh = {
  code: "en-US",
  formatDistance: Vf,
  formatLong: Uf,
  formatRelative: Gf,
  localize: rh,
  match: yh,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function xh(e) {
  const t = ne(e);
  return Ui(t, Lf(t)) + 1;
}
function _h(e) {
  const t = ne(e), r = +Ar(t) - +Af(t);
  return Math.round(r / Hi) + 1;
}
function Gi(e, t) {
  var d, h, v, m;
  const r = ne(e), n = r.getFullYear(), a = cr(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((h = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : h.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((m = (v = a.locale) == null ? void 0 : v.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, o = De(e, 0);
  o.setFullYear(n + 1, 0, i), o.setHours(0, 0, 0, 0);
  const s = Et(o, t), c = De(e, 0);
  c.setFullYear(n, 0, i), c.setHours(0, 0, 0, 0);
  const u = Et(c, t);
  return r.getTime() >= s.getTime() ? n + 1 : r.getTime() >= u.getTime() ? n : n - 1;
}
function wh(e, t) {
  var s, c, u, d;
  const r = cr(), n = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((d = (u = r.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, a = Gi(e, t), i = De(e, 0);
  return i.setFullYear(a, 0, n), i.setHours(0, 0, 0, 0), Et(i, t);
}
function Th(e, t) {
  const r = ne(e), n = +Et(r, t) - +wh(r, t);
  return Math.round(n / Hi) + 1;
}
function H(e, t) {
  const r = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(t, "0");
  return r + n;
}
const We = {
  // Year
  y(e, t) {
    const r = e.getFullYear(), n = r > 0 ? r : 1 - r;
    return H(t === "yy" ? n % 100 : n, t.length);
  },
  // Month
  M(e, t) {
    const r = e.getMonth();
    return t === "M" ? String(r + 1) : H(r + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return H(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return H(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return H(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return H(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return H(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const r = t.length, n = e.getMilliseconds(), a = Math.trunc(
      n * Math.pow(10, r - 3)
    );
    return H(a, t.length);
  }
}, pt = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Ha = {
  // Era
  G: function(e, t, r) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(n, { width: "abbreviated" });
      case "GGGGG":
        return r.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, r) {
    if (t === "yo") {
      const n = e.getFullYear(), a = n > 0 ? n : 1 - n;
      return r.ordinalNumber(a, { unit: "year" });
    }
    return We.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, r, n) {
    const a = Gi(e, n), i = a > 0 ? a : 1 - a;
    if (t === "YY") {
      const o = i % 100;
      return H(o, 2);
    }
    return t === "Yo" ? r.ordinalNumber(i, { unit: "year" }) : H(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const r = Yi(e);
    return H(r, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const r = e.getFullYear();
    return H(r, t.length);
  },
  // Quarter
  Q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(n);
      case "QQ":
        return H(n, 2);
      case "Qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(n);
      case "qq":
        return H(n, 2);
      case "qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return We.M(e, t);
      case "Mo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      case "MMM":
        return r.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "L":
        return String(n + 1);
      case "LL":
        return H(n + 1, 2);
      case "Lo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      case "LLL":
        return r.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, r, n) {
    const a = Th(e, n);
    return t === "wo" ? r.ordinalNumber(a, { unit: "week" }) : H(a, t.length);
  },
  // ISO week of year
  I: function(e, t, r) {
    const n = _h(e);
    return t === "Io" ? r.ordinalNumber(n, { unit: "week" }) : H(n, t.length);
  },
  // Day of the month
  d: function(e, t, r) {
    return t === "do" ? r.ordinalNumber(e.getDate(), { unit: "date" }) : We.d(e, t);
  },
  // Day of year
  D: function(e, t, r) {
    const n = xh(e);
    return t === "Do" ? r.ordinalNumber(n, { unit: "dayOfYear" }) : H(n, t.length);
  },
  // Day of week
  E: function(e, t, r) {
    const n = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, r, n) {
    const a = e.getDay(), i = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(i);
      case "ee":
        return H(i, 2);
      case "eo":
        return r.ordinalNumber(i, { unit: "day" });
      case "eee":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, r, n) {
    const a = e.getDay(), i = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(i);
      case "cc":
        return H(i, t.length);
      case "co":
        return r.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return r.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, r) {
    const n = e.getDay(), a = n === 0 ? 7 : n;
    switch (t) {
      case "i":
        return String(a);
      case "ii":
        return H(a, t.length);
      case "io":
        return r.ordinalNumber(a, { unit: "day" });
      case "iii":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, r) {
    const a = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, r) {
    const n = e.getHours();
    let a;
    switch (n === 12 ? a = pt.noon : n === 0 ? a = pt.midnight : a = n / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, r) {
    const n = e.getHours();
    let a;
    switch (n >= 17 ? a = pt.evening : n >= 12 ? a = pt.afternoon : n >= 4 ? a = pt.morning : a = pt.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, r) {
    if (t === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), r.ordinalNumber(n, { unit: "hour" });
    }
    return We.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, r) {
    return t === "Ho" ? r.ordinalNumber(e.getHours(), { unit: "hour" }) : We.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, r) {
    const n = e.getHours() % 12;
    return t === "Ko" ? r.ordinalNumber(n, { unit: "hour" }) : H(n, t.length);
  },
  // Hour [1-24]
  k: function(e, t, r) {
    let n = e.getHours();
    return n === 0 && (n = 24), t === "ko" ? r.ordinalNumber(n, { unit: "hour" }) : H(n, t.length);
  },
  // Minute
  m: function(e, t, r) {
    return t === "mo" ? r.ordinalNumber(e.getMinutes(), { unit: "minute" }) : We.m(e, t);
  },
  // Second
  s: function(e, t, r) {
    return t === "so" ? r.ordinalNumber(e.getSeconds(), { unit: "second" }) : We.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return We.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, r) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (t) {
      case "X":
        return Ua(n);
      case "XXXX":
      case "XX":
        return Je(n);
      case "XXXXX":
      case "XXX":
      default:
        return Je(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return Ua(n);
      case "xxxx":
      case "xx":
        return Je(n);
      case "xxxxx":
      case "xxx":
      default:
        return Je(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Ya(n, ":");
      case "OOOO":
      default:
        return "GMT" + Je(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Ya(n, ":");
      case "zzzz":
      default:
        return "GMT" + Je(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, r) {
    const n = Math.trunc(e.getTime() / 1e3);
    return H(n, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, r) {
    const n = e.getTime();
    return H(n, t.length);
  }
};
function Ya(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = Math.trunc(n / 60), i = n % 60;
  return i === 0 ? r + String(a) : r + String(a) + t + H(i, 2);
}
function Ua(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + H(Math.abs(e) / 60, 2) : Je(e, t);
}
function Je(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = H(Math.trunc(n / 60), 2), i = H(n % 60, 2);
  return r + a + t + i;
}
const za = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, qi = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, kh = (e, t) => {
  const r = e.match(/(P+)(p+)?/) || [], n = r[1], a = r[2];
  if (!a)
    return za(e, t);
  let i;
  switch (n) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", za(n, t)).replace("{{time}}", qi(a, t));
}, Eh = {
  p: qi,
  P: kh
}, Sh = /^D+$/, Oh = /^Y+$/, jh = ["D", "DD", "YY", "YYYY"];
function Ph(e) {
  return Sh.test(e);
}
function Ch(e) {
  return Oh.test(e);
}
function Nh(e, t, r) {
  const n = $h(e, t, r);
  if (console.warn(n), jh.includes(e)) throw new RangeError(n);
}
function $h(e, t, r) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${n} to the input \`${r}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Mh = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Ah = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Dh = /^'([^]*?)'?$/, Rh = /''/g, Ih = /[a-zA-Z]/;
function Ft(e, t, r) {
  var d, h, v, m;
  const n = cr(), a = n.locale ?? bh, i = n.firstWeekContainsDate ?? ((h = (d = n.locale) == null ? void 0 : d.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, o = n.weekStartsOn ?? ((m = (v = n.locale) == null ? void 0 : v.options) == null ? void 0 : m.weekStartsOn) ?? 0, s = ne(e);
  if (!If(s))
    throw new RangeError("Invalid time value");
  let c = t.match(Ah).map((y) => {
    const w = y[0];
    if (w === "p" || w === "P") {
      const O = Eh[w];
      return O(y, a.formatLong);
    }
    return y;
  }).join("").match(Mh).map((y) => {
    if (y === "''")
      return { isToken: !1, value: "'" };
    const w = y[0];
    if (w === "'")
      return { isToken: !1, value: Fh(y) };
    if (Ha[w])
      return { isToken: !0, value: y };
    if (w.match(Ih))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + w + "`"
      );
    return { isToken: !1, value: y };
  });
  a.localize.preprocessor && (c = a.localize.preprocessor(s, c));
  const u = {
    firstWeekContainsDate: i,
    weekStartsOn: o,
    locale: a
  };
  return c.map((y) => {
    if (!y.isToken) return y.value;
    const w = y.value;
    (Ch(w) || Ph(w)) && Nh(w, t, String(e));
    const O = Ha[w[0]];
    return O(s, w, a.localize, u);
  }).join("");
}
function Fh(e) {
  const t = e.match(Dh);
  return t ? t[1].replace(Rh, "'") : e;
}
function Lh(e, t) {
  const r = ne(e), n = ne(t);
  return +r < +n;
}
function Ga(e) {
  return Zt(e, Df(e));
}
function Wh(e, t) {
  return zi(e, -t);
}
function Zh({
  title: e,
  titleId: t,
  ...r
}, n) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": t
  }, r), e ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M7.72 12.53a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.06 1.06L9.31 12l6.97 6.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5Z",
    clipRule: "evenodd"
  }));
}
const Vh = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(Zh);
function Bh({
  title: e,
  titleId: t,
  ...r
}, n) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": t
  }, r), e ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z",
    clipRule: "evenodd"
  }));
}
const Hh = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(Bh), Yh = ({ onSelect: e, day: t }) => {
  const r = (i) => i.isDisabled || !i.isAvailable || i.availabilitiesCount === 0, n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), a = () => {
    n.current && n.current.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
  };
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    t.isSelected && a();
  }, [t.isSelected]), /* @__PURE__ */ f.jsxs(
    "button",
    {
      type: "button",
      onClick: () => e(t.date),
      disabled: r(t),
      className: I(
        "flex flex-1 md:flex-col justify-between md:justify-center align-center p-3",
        "font-bold text-lg text-center rounded-md",
        "w-full md:w-auto",
        {
          "border-slate-200 border-1 bg-white": !t.isSelected,
          "border-1 border-primary ring-4 ring-secondary": t.isSelected,
          "bg-slate-100 cursor-not-allowed text-slate-300 border-1 border-slate-200": t.isDisabled,
          "hover:z-10 hover:bg-secondary hover:border-primary cursor-pointer": !r(t)
        }
      ),
      children: [
        /* @__PURE__ */ f.jsxs(
          "time",
          {
            dateTime: t.date.toISOString(),
            className: I(
              "flex flex-row md:flex-none md:block gap-1 md:self-center",
              {
                "text-slate-400": r(t),
                "text-slate-800": !r(t) && !t.isSelected,
                "text-primary": t.isSelected
              }
            ),
            children: [
              /* @__PURE__ */ f.jsx("div", { className: "font-medium", children: t.shortDayName }),
              /* @__PURE__ */ f.jsx("div", { children: t.date.getDate() }),
              /* @__PURE__ */ f.jsx("div", { children: Ft(t.date, "MMM") })
            ]
          }
        ),
        /* @__PURE__ */ f.jsx(
          "div",
          {
            className: I("self-center flex", {
              "text-slate-400": !0
            }),
            ref: n,
            children: /* @__PURE__ */ f.jsx(
              Uh,
              {
                count: !t.isAvailable || t.isDisabled ? 0 : t.availabilitiesCount
              }
            )
          }
        )
      ]
    },
    t.date.toString()
  );
}, Uh = ({ count: e }) => {
  const t = e === 1 ? "slot" : "slots";
  return /* @__PURE__ */ f.jsx("div", { className: "flex mt-2 gap-2 md:gap-0 md:flex-col flex-row", children: /* @__PURE__ */ f.jsx(
    "div",
    {
      className: I(
        "rounded-full text-sm text-white font-medium my-2 self-center px-4 py-1 w-[85px]",
        {
          "bg-slate-300": e === 0,
          "bg-yellow-500": e > 0 && e <= 2,
          "bg-green-600": e > 2
        }
      ),
      "aria-hidden": "true",
      children: e === 0 ? "No slots" : `${e} ${t}`
    }
  ) });
}, zh = ({
  value: e,
  onSelect: t,
  week: r = /* @__PURE__ */ new Date(),
  weekStartsOn: n = "monday",
  hideWeekends: a = !0,
  allowSchedulingInThePast: i = !1,
  preferredLocation: o = "Virtual"
}) => {
  const [s, c] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(r), [u, d] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(e), [h, v] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), [m, y] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), { setDeliveryMethod: w } = Se(), {
    availabilities: { data: O, loading: C }
  } = Hn();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    U(o);
  }, [O]);
  const S = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    c((A) => Wh(A, 1));
  }, []), J = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    c((A) => zi(A, 1));
  }, []), U = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (A) => {
      v(A), w(A === "Virtual" ? "virtual" : "in-person"), d(null), t(null), y(
        A !== "Virtual" ? O.filter(
          (q) => q.facility === A && q.location === Vn.Both
        ) : O
      );
    },
    [O, o]
  ), ae = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    const A = ki(
      O.map((q) => q.facility ? q.facility : "Virtual")
    );
    return A.includes("Virtual") || A.push("Virtual"), A;
  }, [O]), F = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (A) => {
      d(A), t(A);
    },
    [t]
  ), z = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (A) => m.some(
      (q) => Zt(A, q.slotstart)
    ),
    [m]
  ), k = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (A) => !!(Lh(A, /* @__PURE__ */ new Date()) && !Ga(A) && !i),
    [i]
  ), Q = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (A) => m.filter(
      (q) => Zt(q.slotstart, A)
    ).length,
    [m]
  ), pe = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    const A = n === "sunday" ? 0 : 1, q = Et(s, { weekStartsOn: A }), $e = Wf(s, { weekStartsOn: A });
    let Fe = Ff({ start: q, end: $e }).map((ue) => ({
      date: ue,
      isToday: Ga(ue),
      isSelected: u ? Zt(ue, u) : !1,
      isDisabled: k(ue),
      isAvailable: z(ue),
      shortDayName: Ft(ue, "EEE"),
      availabilitiesCount: Q(ue)
    }));
    return a && (Fe = Fe.filter(
      (ue) => Ft(ue.date, "EEE") !== "Sat" && Ft(ue.date, "EEE") !== "Sun"
    )), Fe;
  }, [
    s,
    u,
    a,
    n,
    h,
    m,
    i
  ]), ve = Va(s, /* @__PURE__ */ new Date()) <= -7, oe = Va(s, /* @__PURE__ */ new Date()) >= 30;
  return /* @__PURE__ */ f.jsxs("div", { className: "relative", children: [
    C && /* @__PURE__ */ f.jsx("div", { className: "absolute w-full h-full top-0 left-0 flex items-center justify-center bg-opacity-70 bg-white", children: /* @__PURE__ */ f.jsx("span", { className: "loading loading-spinner loading-lg text-primary" }) }),
    /* @__PURE__ */ f.jsx(
      Gh,
      {
        options: ae,
        selected: h,
        onSelect: U
      }
    ),
    /* @__PURE__ */ f.jsxs("div", { className: "flex justify-between align-center mb-4 items-center", children: [
      /* @__PURE__ */ f.jsx("div", { className: "text-lg font-medium", children: `${Ft(s, "MMMM yyyy")}` }),
      /* @__PURE__ */ f.jsxs("div", { className: "flex align-center text-center gap-2", children: [
        /* @__PURE__ */ f.jsx(
          qa,
          {
            direction: "left",
            onClick: S,
            isDisabled: ve
          }
        ),
        /* @__PURE__ */ f.jsx(
          qa,
          {
            direction: "right",
            onClick: J,
            isDisabled: oe
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ f.jsx(
      "div",
      {
        className: I(
          "flex gap-2 lg:gap-3 flex-col md:flex-row overflow-x-auto"
        ),
        children: pe.map((A) => /* @__PURE__ */ f.jsx(
          Yh,
          {
            day: A,
            onSelect: F
          },
          A.date.toString()
        ))
      }
    )
  ] });
}, Gh = ({ options: e, selected: t, onSelect: r }) => /* @__PURE__ */ f.jsx("ul", { className: "menu menu-horizontal rounded-box gap-2 pl-0", children: e.map((n) => /* @__PURE__ */ f.jsx("li", { children: /* @__PURE__ */ f.jsx(
  "button",
  {
    className: I(
      "btn btn-sm hover:bg-secondary hover:border-1 hover:border-primary",
      {
        "text-slate-800 border-1 border-slate-200  bg-white": n !== t,
        "border-1 border-primary ring-4 ring-secondary text-primary": n === t
      }
    ),
    onClick: () => r(n),
    children: n
  }
) }, n)) }), qa = ({ direction: e, onClick: t, isDisabled: r }) => {
  const n = I(
    "flex flex-none align-center justify-center",
    "text-primary size-8 font-bold"
  );
  return /* @__PURE__ */ f.jsx(
    "button",
    {
      onClick: t,
      className: I("btn", {
        "btn-disabled opacity-50 cursor-not-allowed": r,
        "btn-secondary": !r
      }),
      disabled: r,
      "aria-label": e === "left" ? "Go to previous week" : "Go to next week",
      children: e === "left" ? /* @__PURE__ */ f.jsx(Vh, { className: n, "aria-hidden": "true" }) : /* @__PURE__ */ f.jsx(Hh, { className: n, "aria-hidden": "true" })
    }
  );
}, Xi = typeof document < "u" ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : () => {
};
function qh(e) {
  const t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  return Xi(() => {
    t.current = e;
  }, [
    e
  ]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((...r) => {
    const n = t.current;
    return n == null ? void 0 : n(...r);
  }, []);
}
const lr = (e) => {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) !== null && t !== void 0 ? t : document;
}, tt = (e) => e && "window" in e && e.window === e ? e : lr(e).defaultView || window;
function Xh(e) {
  var t;
  return typeof window > "u" || window.navigator == null ? !1 : ((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands.some((r) => e.test(r.brand))) || e.test(window.navigator.userAgent);
}
function Kh(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function Ki(e) {
  let t = null;
  return () => (t == null && (t = e()), t);
}
const Jh = Ki(function() {
  return Kh(/^Mac/i);
}), Qh = Ki(function() {
  return Xh(/Android/i);
});
function em(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : Qh() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
class tm {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = !0, this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation(), this.isPropagationStopped = () => !0;
  }
  isPropagationStopped() {
    return !1;
  }
  persist() {
  }
  constructor(t, r) {
    this.nativeEvent = r, this.target = r.target, this.currentTarget = r.currentTarget, this.relatedTarget = r.relatedTarget, this.bubbles = r.bubbles, this.cancelable = r.cancelable, this.defaultPrevented = r.defaultPrevented, this.eventPhase = r.eventPhase, this.isTrusted = r.isTrusted, this.timeStamp = r.timeStamp, this.type = t;
  }
}
function Ji(e) {
  let t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    isFocused: !1,
    observer: null
  });
  Xi(() => {
    const n = t.current;
    return () => {
      n.observer && (n.observer.disconnect(), n.observer = null);
    };
  }, []);
  let r = qh((n) => {
    e == null || e(n);
  });
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((n) => {
    if (n.target instanceof HTMLButtonElement || n.target instanceof HTMLInputElement || n.target instanceof HTMLTextAreaElement || n.target instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let a = n.target, i = (o) => {
        t.current.isFocused = !1, a.disabled && r(new tm("blur", o)), t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      a.addEventListener("focusout", i, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && a.disabled) {
          var o;
          (o = t.current.observer) === null || o === void 0 || o.disconnect();
          let s = a === document.activeElement ? null : document.activeElement;
          a.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: s
          })), a.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: s
          }));
        }
      }), t.current.observer.observe(a, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    r
  ]);
}
function rm(e) {
  let { isDisabled: t, onFocus: r, onBlur: n, onFocusChange: a } = e;
  const i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((c) => {
    if (c.target === c.currentTarget)
      return n && n(c), a && a(!1), !0;
  }, [
    n,
    a
  ]), o = Ji(i), s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((c) => {
    const u = lr(c.target);
    c.target === c.currentTarget && u.activeElement === c.target && (r && r(c), a && a(!0), o(c));
  }, [
    a,
    r,
    o
  ]);
  return {
    focusProps: {
      onFocus: !t && (r || a || n) ? s : void 0,
      onBlur: !t && (n || a) ? i : void 0
    }
  };
}
let ur = null, jn = /* @__PURE__ */ new Set(), Vt = /* @__PURE__ */ new Map(), st = !1, Pn = !1;
const nm = {
  Tab: !0,
  Escape: !0
};
function Yn(e, t) {
  for (let r of jn) r(e, t);
}
function am(e) {
  return !(e.metaKey || !Jh() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function Rr(e) {
  st = !0, am(e) && (ur = "keyboard", Yn("keyboard", e));
}
function xe(e) {
  ur = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (st = !0, Yn("pointer", e));
}
function Qi(e) {
  em(e) && (st = !0, ur = "virtual");
}
function es(e) {
  e.target === window || e.target === document || (!st && !Pn && (ur = "virtual", Yn("virtual", e)), st = !1, Pn = !1);
}
function ts() {
  st = !1, Pn = !0;
}
function Cn(e) {
  if (typeof window > "u" || Vt.get(tt(e))) return;
  const t = tt(e), r = lr(e);
  let n = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    st = !0, n.apply(this, arguments);
  }, r.addEventListener("keydown", Rr, !0), r.addEventListener("keyup", Rr, !0), r.addEventListener("click", Qi, !0), t.addEventListener("focus", es, !0), t.addEventListener("blur", ts, !1), typeof PointerEvent < "u" ? (r.addEventListener("pointerdown", xe, !0), r.addEventListener("pointermove", xe, !0), r.addEventListener("pointerup", xe, !0)) : (r.addEventListener("mousedown", xe, !0), r.addEventListener("mousemove", xe, !0), r.addEventListener("mouseup", xe, !0)), t.addEventListener("beforeunload", () => {
    rs(e);
  }, {
    once: !0
  }), Vt.set(t, {
    focus: n
  });
}
const rs = (e, t) => {
  const r = tt(e), n = lr(e);
  t && n.removeEventListener("DOMContentLoaded", t), Vt.has(r) && (r.HTMLElement.prototype.focus = Vt.get(r).focus, n.removeEventListener("keydown", Rr, !0), n.removeEventListener("keyup", Rr, !0), n.removeEventListener("click", Qi, !0), r.removeEventListener("focus", es, !0), r.removeEventListener("blur", ts, !1), typeof PointerEvent < "u" ? (n.removeEventListener("pointerdown", xe, !0), n.removeEventListener("pointermove", xe, !0), n.removeEventListener("pointerup", xe, !0)) : (n.removeEventListener("mousedown", xe, !0), n.removeEventListener("mousemove", xe, !0), n.removeEventListener("mouseup", xe, !0)), Vt.delete(r));
};
function im(e) {
  const t = lr(e);
  let r;
  return t.readyState !== "loading" ? Cn(e) : (r = () => {
    Cn(e);
  }, t.addEventListener("DOMContentLoaded", r)), () => rs(e, r);
}
typeof document < "u" && im();
function ns() {
  return ur !== "pointer";
}
const sm = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function om(e, t, r) {
  var n;
  const a = typeof window < "u" ? tt(r == null ? void 0 : r.target).HTMLInputElement : HTMLInputElement, i = typeof window < "u" ? tt(r == null ? void 0 : r.target).HTMLTextAreaElement : HTMLTextAreaElement, o = typeof window < "u" ? tt(r == null ? void 0 : r.target).HTMLElement : HTMLElement, s = typeof window < "u" ? tt(r == null ? void 0 : r.target).KeyboardEvent : KeyboardEvent;
  return e = e || (r == null ? void 0 : r.target) instanceof a && !sm.has(r == null || (n = r.target) === null || n === void 0 ? void 0 : n.type) || (r == null ? void 0 : r.target) instanceof i || (r == null ? void 0 : r.target) instanceof o && (r == null ? void 0 : r.target.isContentEditable), !(e && t === "keyboard" && r instanceof s && !nm[r.key]);
}
function cm(e, t, r) {
  Cn(), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    let n = (a, i) => {
      om(!!(r != null && r.isTextInput), a, i) && e(ns());
    };
    return jn.add(n), () => {
      jn.delete(n);
    };
  }, t);
}
function lm(e) {
  let { isDisabled: t, onBlurWithin: r, onFocusWithin: n, onFocusWithinChange: a } = e, i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    isFocusWithin: !1
  }), o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((u) => {
    i.current.isFocusWithin && !u.currentTarget.contains(u.relatedTarget) && (i.current.isFocusWithin = !1, r && r(u), a && a(!1));
  }, [
    r,
    a,
    i
  ]), s = Ji(o), c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((u) => {
    !i.current.isFocusWithin && document.activeElement === u.target && (n && n(u), a && a(!0), i.current.isFocusWithin = !0, s(u));
  }, [
    n,
    a,
    s
  ]);
  return t ? {
    focusWithinProps: {
      // These should not have been null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: c,
      onBlur: o
    }
  };
}
let Ir = !1, hn = 0;
function Nn() {
  Ir = !0, setTimeout(() => {
    Ir = !1;
  }, 50);
}
function Xa(e) {
  e.pointerType === "touch" && Nn();
}
function um() {
  if (!(typeof document > "u"))
    return typeof PointerEvent < "u" ? document.addEventListener("pointerup", Xa) : document.addEventListener("touchend", Nn), hn++, () => {
      hn--, !(hn > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", Xa) : document.removeEventListener("touchend", Nn));
    };
}
function as(e) {
  let { onHoverStart: t, onHoverChange: r, onHoverEnd: n, isDisabled: a } = e, [i, o] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(um, []);
  let { hoverProps: c, triggerHoverEnd: u } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    let d = (m, y) => {
      if (s.pointerType = y, a || y === "touch" || s.isHovered || !m.currentTarget.contains(m.target)) return;
      s.isHovered = !0;
      let w = m.currentTarget;
      s.target = w, t && t({
        type: "hoverstart",
        target: w,
        pointerType: y
      }), r && r(!0), o(!0);
    }, h = (m, y) => {
      if (s.pointerType = "", s.target = null, y === "touch" || !s.isHovered) return;
      s.isHovered = !1;
      let w = m.currentTarget;
      n && n({
        type: "hoverend",
        target: w,
        pointerType: y
      }), r && r(!1), o(!1);
    }, v = {};
    return typeof PointerEvent < "u" ? (v.onPointerEnter = (m) => {
      Ir && m.pointerType === "mouse" || d(m, m.pointerType);
    }, v.onPointerLeave = (m) => {
      !a && m.currentTarget.contains(m.target) && h(m, m.pointerType);
    }) : (v.onTouchStart = () => {
      s.ignoreEmulatedMouseEvents = !0;
    }, v.onMouseEnter = (m) => {
      !s.ignoreEmulatedMouseEvents && !Ir && d(m, "mouse"), s.ignoreEmulatedMouseEvents = !1;
    }, v.onMouseLeave = (m) => {
      !a && m.currentTarget.contains(m.target) && h(m, "mouse");
    }), {
      hoverProps: v,
      triggerHoverEnd: h
    };
  }, [
    t,
    r,
    n,
    a,
    s
  ]);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    a && u({
      currentTarget: s.target
    }, s.pointerType);
  }, [
    a
  ]), {
    hoverProps: c,
    isHovered: i
  };
}
function is(e = {}) {
  let { autoFocus: t = !1, isTextInput: r, within: n } = e, a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    isFocused: !1,
    isFocusVisible: t || ns()
  }), [i, o] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), [s, c] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => a.current.isFocused && a.current.isFocusVisible), u = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => c(a.current.isFocused && a.current.isFocusVisible), []), d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((m) => {
    a.current.isFocused = m, o(m), u();
  }, [
    u
  ]);
  cm((m) => {
    a.current.isFocusVisible = m, u();
  }, [], {
    isTextInput: r
  });
  let { focusProps: h } = rm({
    isDisabled: n,
    onFocusChange: d
  }), { focusWithinProps: v } = lm({
    isDisabled: !n,
    onFocusWithinChange: d
  });
  return {
    isFocused: i,
    isFocusVisible: s,
    focusProps: n ? v : h
  };
}
var dm = Object.defineProperty, fm = (e, t, r) => t in e ? dm(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, mn = (e, t, r) => (fm(e, typeof t != "symbol" ? t + "" : t, r), r);
let hm = class {
  constructor() {
    mn(this, "current", this.detect()), mn(this, "handoffState", "pending"), mn(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.handoffState = "pending", this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
}, ss = new hm();
function mm(e) {
  return ss.isServer ? null : e instanceof Node ? e.ownerDocument : e != null && e.hasOwnProperty("current") && e.current instanceof Node ? e.current.ownerDocument : document;
}
function pm(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function os() {
  let e = [], t = { addEventListener(r, n, a, i) {
    return r.addEventListener(n, a, i), t.add(() => r.removeEventListener(n, a, i));
  }, requestAnimationFrame(...r) {
    let n = requestAnimationFrame(...r);
    return t.add(() => cancelAnimationFrame(n));
  }, nextFrame(...r) {
    return t.requestAnimationFrame(() => t.requestAnimationFrame(...r));
  }, setTimeout(...r) {
    let n = setTimeout(...r);
    return t.add(() => clearTimeout(n));
  }, microTask(...r) {
    let n = { current: !0 };
    return pm(() => {
      n.current && r[0]();
    }), t.add(() => {
      n.current = !1;
    });
  }, style(r, n, a) {
    let i = r.style.getPropertyValue(n);
    return Object.assign(r.style, { [n]: a }), this.add(() => {
      Object.assign(r.style, { [n]: i });
    });
  }, group(r) {
    let n = os();
    return r(n), this.add(() => n.dispose());
  }, add(r) {
    return e.includes(r) || e.push(r), () => {
      let n = e.indexOf(r);
      if (n >= 0) for (let a of e.splice(n, 1)) a();
    };
  }, dispose() {
    for (let r of e.splice(0)) r();
  } };
  return t;
}
function gm() {
  let [e] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(os);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => () => e.dispose(), [e]), e;
}
let dr = (e, t) => {
  ss.isServer ? (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(e, t) : (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(e, t);
};
function Un(e) {
  let t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(e);
  return dr(() => {
    t.current = e;
  }, [e]), t;
}
let je = function(e) {
  let t = Un(e);
  return react__WEBPACK_IMPORTED_MODULE_0__.useCallback((...r) => t.current(...r), [t]);
}, cs = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(void 0);
function fr() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(cs);
}
function vm({ value: e, children: t }) {
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(cs.Provider, { value: e }, t);
}
function Ka(...e) {
  return Array.from(new Set(e.flatMap((t) => typeof t == "string" ? t.split(" ") : []))).filter(Boolean).join(" ");
}
function zn(e, t, ...r) {
  if (e in t) {
    let a = t[e];
    return typeof a == "function" ? a(...r) : a;
  }
  let n = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((a) => `"${a}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(n, zn), n;
}
var ym = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(ym || {}), bm = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(bm || {});
function dt({ ourProps: e, theirProps: t, slot: r, defaultTag: n, features: a, visible: i = !0, name: o, mergeRefs: s }) {
  s = s ?? xm;
  let c = ls(t, e);
  if (i) return xr(c, r, n, o, s);
  let u = a ?? 0;
  if (u & 2) {
    let { static: d = !1, ...h } = c;
    if (d) return xr(h, r, n, o, s);
  }
  if (u & 1) {
    let { unmount: d = !0, ...h } = c;
    return zn(d ? 0 : 1, { 0() {
      return null;
    }, 1() {
      return xr({ ...h, hidden: !0, style: { display: "none" } }, r, n, o, s);
    } });
  }
  return xr(c, r, n, o, s);
}
function xr(e, t = {}, r, n, a) {
  let { as: i = r, children: o, refName: s = "ref", ...c } = pn(e, ["unmount", "static"]), u = e.ref !== void 0 ? { [s]: e.ref } : {}, d = typeof o == "function" ? o(t) : o;
  "className" in c && c.className && typeof c.className == "function" && (c.className = c.className(t)), c["aria-labelledby"] && c["aria-labelledby"] === c.id && (c["aria-labelledby"] = void 0);
  let h = {};
  if (t) {
    let v = !1, m = [];
    for (let [y, w] of Object.entries(t)) typeof w == "boolean" && (v = !0), w === !0 && m.push(y.replace(/([A-Z])/g, (O) => `-${O.toLowerCase()}`));
    if (v) {
      h["data-headlessui-state"] = m.join(" ");
      for (let y of m) h[`data-${y}`] = "";
    }
  }
  if (i === react__WEBPACK_IMPORTED_MODULE_0__.Fragment && (Object.keys(Qe(c)).length > 0 || Object.keys(Qe(h)).length > 0)) if (!(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(d) || Array.isArray(d) && d.length > 1) {
    if (Object.keys(Qe(c)).length > 0) throw new Error(['Passing props on "Fragment"!', "", `The current component <${n} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(Qe(c)).concat(Object.keys(Qe(h))).map((v) => `  - ${v}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((v) => `  - ${v}`).join(`
`)].join(`
`));
  } else {
    let v = d.props, m = v == null ? void 0 : v.className, y = typeof m == "function" ? (...C) => Ka(m(...C), c.className) : Ka(m, c.className), w = y ? { className: y } : {}, O = ls(d.props, Qe(pn(c, ["ref"])));
    for (let C in h) C in O && delete h[C];
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(d, Object.assign({}, O, h, u, { ref: a(d.ref, u.ref) }, w));
  }
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(i, Object.assign({}, pn(c, ["ref"]), i !== react__WEBPACK_IMPORTED_MODULE_0__.Fragment && u, i !== react__WEBPACK_IMPORTED_MODULE_0__.Fragment && h), d);
}
function xm(...e) {
  return e.every((t) => t == null) ? void 0 : (t) => {
    for (let r of e) r != null && (typeof r == "function" ? r(t) : r.current = t);
  };
}
function ls(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let t = {}, r = {};
  for (let n of e) for (let a in n) a.startsWith("on") && typeof n[a] == "function" ? (r[a] != null || (r[a] = []), r[a].push(n[a])) : t[a] = n[a];
  if (t.disabled || t["aria-disabled"]) for (let n in r) /^(on(?:Click|Pointer|Mouse|Key)(?:Down|Up|Press)?)$/.test(n) && (r[n] = [(a) => {
    var i;
    return (i = a == null ? void 0 : a.preventDefault) == null ? void 0 : i.call(a);
  }]);
  for (let n in r) Object.assign(t, { [n](a, ...i) {
    let o = r[n];
    for (let s of o) {
      if ((a instanceof Event || (a == null ? void 0 : a.nativeEvent) instanceof Event) && a.defaultPrevented) return;
      s(a, ...i);
    }
  } });
  return t;
}
function us(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let t = {}, r = {};
  for (let n of e) for (let a in n) a.startsWith("on") && typeof n[a] == "function" ? (r[a] != null || (r[a] = []), r[a].push(n[a])) : t[a] = n[a];
  for (let n in r) Object.assign(t, { [n](...a) {
    let i = r[n];
    for (let o of i) o == null || o(...a);
  } });
  return t;
}
function ft(e) {
  var t;
  return Object.assign((0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(e), { displayName: (t = e.displayName) != null ? t : e.name });
}
function Qe(e) {
  let t = Object.assign({}, e);
  for (let r in t) t[r] === void 0 && delete t[r];
  return t;
}
function pn(e, t = []) {
  let r = Object.assign({}, e);
  for (let n of t) n in r && delete r[n];
  return r;
}
function _m(e, t, r) {
  let [n, a] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(r), i = e !== void 0, o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(i), s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1), c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1);
  return i && !o.current && !s.current ? (s.current = !0, o.current = i, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !i && o.current && !c.current && (c.current = !0, o.current = i, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [i ? e : n, je((u) => (i || a(u), t == null ? void 0 : t(u)))];
}
function wm(e) {
  let [t] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(e);
  return t;
}
function ds(e = {}, t = null, r = []) {
  for (let [n, a] of Object.entries(e)) hs(r, fs(t, n), a);
  return r;
}
function fs(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function hs(e, t, r) {
  if (Array.isArray(r)) for (let [n, a] of r.entries()) hs(e, fs(t, n.toString()), a);
  else r instanceof Date ? e.push([t, r.toISOString()]) : typeof r == "boolean" ? e.push([t, r ? "1" : "0"]) : typeof r == "string" ? e.push([t, r]) : typeof r == "number" ? e.push([t, `${r}`]) : r == null ? e.push([t, ""]) : ds(r, t, e);
}
function Tm(e) {
  var t, r;
  let n = (t = e == null ? void 0 : e.form) != null ? t : e.closest("form");
  if (n) {
    for (let a of n.elements) if (a !== e && (a.tagName === "INPUT" && a.type === "submit" || a.tagName === "BUTTON" && a.type === "submit" || a.nodeName === "INPUT" && a.type === "image")) {
      a.click();
      return;
    }
    (r = n.requestSubmit) == null || r.call(n);
  }
}
let km = "span";
var Yr = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(Yr || {});
function Em(e, t) {
  var r;
  let { features: n = 1, ...a } = e, i = { ref: t, "aria-hidden": (n & 2) === 2 ? !0 : (r = a["aria-hidden"]) != null ? r : void 0, hidden: (n & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(n & 4) === 4 && (n & 2) !== 2 && { display: "none" } } };
  return dt({ ourProps: i, theirProps: a, slot: {}, defaultTag: km, name: "Hidden" });
}
let Gn = ft(Em), ms = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
function Sm(e) {
  let [t, r] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(ms.Provider, { value: { target: t } }, e.children, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Gn, { features: Yr.Hidden, ref: r }));
}
function Om({ children: e }) {
  let t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ms);
  if (!t) return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, e);
  let { target: r } = t;
  return r ? (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal)(react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, e), r) : null;
}
function jm({ data: e, form: t, disabled: r, onReset: n, overrides: a }) {
  let [i, o] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), s = gm();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (n && i) return s.addEventListener(i, "reset", n);
  }, [i, t, n]), react__WEBPACK_IMPORTED_MODULE_0__.createElement(Om, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Pm, { setForm: o, formId: t }), ds(e).map(([c, u]) => react__WEBPACK_IMPORTED_MODULE_0__.createElement(Gn, { features: Yr.Hidden, ...Qe({ key: c, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: t, disabled: r, name: c, value: u, ...a }) })));
}
function Pm({ setForm: e, formId: t }) {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (t) {
      let r = document.getElementById(t);
      r && e(r);
    }
  }, [e, t]), t ? null : react__WEBPACK_IMPORTED_MODULE_0__.createElement(Gn, { features: Yr.Hidden, as: "input", type: "hidden", hidden: !0, readOnly: !0, ref: (r) => {
    if (!r) return;
    let n = r.closest("form");
    n && e(n);
  } });
}
let ps = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(void 0);
function gs() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ps);
}
function Cm({ id: e, children: t }) {
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(ps.Provider, { value: e }, t);
}
function vs(e) {
  let t = e.parentElement, r = null;
  for (; t && !(t instanceof HTMLFieldSetElement); ) t instanceof HTMLLegendElement && (r = t), t = t.parentElement;
  let n = (t == null ? void 0 : t.getAttribute("disabled")) === "";
  return n && Nm(r) ? !1 : n;
}
function Nm(e) {
  if (!e) return !1;
  let t = e.previousElementSibling;
  for (; t !== null; ) {
    if (t instanceof HTMLLegendElement) return !1;
    t = t.previousElementSibling;
  }
  return !0;
}
let $m = Symbol();
function hr(...e) {
  let t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(e);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    t.current = e;
  }, [e]);
  let r = je((n) => {
    for (let a of t.current) a != null && (typeof a == "function" ? a(n) : a.current = n);
  });
  return e.every((n) => n == null || (n == null ? void 0 : n[$m])) ? void 0 : r;
}
let Ur = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
Ur.displayName = "DescriptionContext";
function ys() {
  let e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Ur);
  if (e === null) {
    let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, ys), t;
  }
  return e;
}
function Mm() {
  var e, t;
  return (t = (e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Ur)) == null ? void 0 : e.value) != null ? t : void 0;
}
function qn() {
  let [e, t] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
  return [e.length > 0 ? e.join(" ") : void 0, (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => function(r) {
    let n = je((i) => (t((o) => [...o, i]), () => t((o) => {
      let s = o.slice(), c = s.indexOf(i);
      return c !== -1 && s.splice(c, 1), s;
    }))), a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({ register: n, slot: r.slot, name: r.name, props: r.props, value: r.value }), [n, r.slot, r.name, r.props, r.value]);
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ur.Provider, { value: a }, r.children);
  }, [t])];
}
let Am = "p";
function Dm(e, t) {
  let r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)(), n = fr(), { id: a = `headlessui-description-${r}`, ...i } = e, o = ys(), s = hr(t);
  dr(() => o.register(a), [a, o.register]);
  let c = n || !1, u = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({ ...o.slot, disabled: c }), [o.slot, c]), d = { ref: s, ...o.props, id: a };
  return dt({ ourProps: d, theirProps: i, slot: u, defaultTag: Am, name: o.name || "Description" });
}
let Rm = ft(Dm), Im = Object.assign(Rm, {});
var et = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(et || {});
let zr = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
zr.displayName = "LabelContext";
function bs() {
  let e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(zr);
  if (e === null) {
    let t = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, bs), t;
  }
  return e;
}
function xs(e) {
  var t, r, n;
  let a = (r = (t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(zr)) == null ? void 0 : t.value) != null ? r : void 0;
  return ((n = void 0) != null ? n : 0) > 0 ? [a, ...e].filter(Boolean).join(" ") : a;
}
function Xn({ inherit: e = !1 } = {}) {
  let t = xs(), [r, n] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), a = e ? [t, ...r].filter(Boolean) : r;
  return [a.length > 0 ? a.join(" ") : void 0, (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => function(i) {
    let o = je((c) => (n((u) => [...u, c]), () => n((u) => {
      let d = u.slice(), h = d.indexOf(c);
      return h !== -1 && d.splice(h, 1), d;
    }))), s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({ register: o, slot: i.slot, name: i.name, props: i.props, value: i.value }), [o, i.slot, i.name, i.props, i.value]);
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(zr.Provider, { value: s }, i.children);
  }, [n])];
}
let Fm = "label";
function Lm(e, t) {
  var r;
  let n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)(), a = bs(), i = gs(), o = fr(), { id: s = `headlessui-label-${n}`, htmlFor: c = i ?? ((r = a.props) == null ? void 0 : r.htmlFor), passive: u = !1, ...d } = e, h = hr(t);
  dr(() => a.register(s), [s, a.register]);
  let v = je((O) => {
    let C = O.currentTarget;
    if (C instanceof HTMLLabelElement && O.preventDefault(), a.props && "onClick" in a.props && typeof a.props.onClick == "function" && a.props.onClick(O), C instanceof HTMLLabelElement) {
      let S = document.getElementById(C.htmlFor);
      if (S) {
        let J = S.getAttribute("disabled");
        if (J === "true" || J === "") return;
        let U = S.getAttribute("aria-disabled");
        if (U === "true" || U === "") return;
        (S instanceof HTMLInputElement && (S.type === "radio" || S.type === "checkbox") || S.role === "radio" || S.role === "checkbox" || S.role === "switch") && S.click(), S.focus({ preventScroll: !0 });
      }
    }
  }), m = o || !1, y = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({ ...a.slot, disabled: m }), [a.slot, m]), w = { ref: h, ...a.props, id: s, htmlFor: c, onClick: v };
  return u && ("onClick" in w && (delete w.htmlFor, delete w.onClick), "onClick" in d && delete d.onClick), dt({ ourProps: w, theirProps: d, slot: y, defaultTag: c ? Fm : "div", name: a.name || "Label" });
}
let Wm = ft(Lm), Zm = Object.assign(Wm, {});
function Vm(e, t) {
  return e !== null && t !== null && typeof e == "object" && typeof t == "object" && "id" in e && "id" in t ? e.id === t.id : e === t;
}
function Bm(e = Vm) {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((t, r) => {
    if (typeof e == "string") {
      let n = e;
      return (t == null ? void 0 : t[n]) === (r == null ? void 0 : r[n]);
    }
    return e(t, r);
  }, [e]);
}
let Hm = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(","), Ym = ["[data-autofocus]"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var Lt = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e[e.AutoFocus = 64] = "AutoFocus", e))(Lt || {}), $n = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))($n || {}), Um = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(Um || {});
function zm(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(Hm)).sort((t, r) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (r.tabIndex || Number.MAX_SAFE_INTEGER)));
}
function Gm(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(Ym)).sort((t, r) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (r.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var qm = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(qm || {}), Xm = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(Xm || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
let Km = ["textarea", "input"].join(",");
function Jm(e) {
  var t, r;
  return (r = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, Km)) != null ? r : !1;
}
function _s(e, t = (r) => r) {
  return e.slice().sort((r, n) => {
    let a = t(r), i = t(n);
    if (a === null || i === null) return 0;
    let o = a.compareDocumentPosition(i);
    return o & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : o & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function Ja(e, t, { sorted: r = !0, relativeTo: n = null, skipElements: a = [] } = {}) {
  let i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, o = Array.isArray(e) ? r ? _s(e) : e : t & 64 ? Gm(e) : zm(e);
  a.length > 0 && o.length > 1 && (o = o.filter((m) => !a.some((y) => y != null && "current" in y ? (y == null ? void 0 : y.current) === m : y === m))), n = n ?? i.activeElement;
  let s = (() => {
    if (t & 5) return 1;
    if (t & 10) return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), c = (() => {
    if (t & 1) return 0;
    if (t & 2) return Math.max(0, o.indexOf(n)) - 1;
    if (t & 4) return Math.max(0, o.indexOf(n)) + 1;
    if (t & 8) return o.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), u = t & 32 ? { preventScroll: !0 } : {}, d = 0, h = o.length, v;
  do {
    if (d >= h || d + h <= 0) return 0;
    let m = c + d;
    if (t & 16) m = (m + h) % h;
    else {
      if (m < 0) return 3;
      if (m >= h) return 1;
    }
    v = o[m], v == null || v.focus(u), d += s;
  } while (v !== i.activeElement);
  return t & 6 && Jm(v) && v.select(), 2;
}
let Qm = "div";
function ep(e, t) {
  let r = `headlessui-control-${(0,react__WEBPACK_IMPORTED_MODULE_0__.useId)()}`, [n, a] = Xn(), [i, o] = qn(), s = fr(), { disabled: c = s || !1, ...u } = e, d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({ disabled: c }), [c]);
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(vm, { value: c }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(a, { value: n }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(o, { value: i }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Cm, { id: r }, dt({ ourProps: { ref: t, disabled: c || void 0, "aria-disabled": c || void 0 }, theirProps: { ...u, children: react__WEBPACK_IMPORTED_MODULE_0__.createElement(Sm, null, typeof u.children == "function" ? u.children(d) : u.children) }, slot: d, defaultTag: Qm, name: "Field" })))));
}
let tp = ft(ep);
var rp = ((e) => (e[e.RegisterOption = 0] = "RegisterOption", e[e.UnregisterOption = 1] = "UnregisterOption", e))(rp || {});
let np = { 0(e, t) {
  let r = [...e.options, { id: t.id, element: t.element, propsRef: t.propsRef }];
  return { ...e, options: _s(r, (n) => n.element.current) };
}, 1(e, t) {
  let r = e.options.slice(), n = e.options.findIndex((a) => a.id === t.id);
  return n === -1 ? e : (r.splice(n, 1), { ...e, options: r });
} }, Kn = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
Kn.displayName = "RadioGroupDataContext";
function Jn(e) {
  let t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Kn);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Jn), r;
  }
  return t;
}
let Qn = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
Qn.displayName = "RadioGroupActionsContext";
function ea(e) {
  let t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Qn);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, ea), r;
  }
  return t;
}
function ap(e, t) {
  return zn(t.type, np, e, t);
}
let ip = "div";
function sp(e, t) {
  let r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)(), n = fr(), { id: a = `headlessui-radiogroup-${r}`, value: i, form: o, name: s, onChange: c, by: u, disabled: d = n || !1, defaultValue: h, ...v } = e, m = Bm(u), [y, w] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(ap, { options: [] }), O = y.options, [C, S] = Xn(), [J, U] = qn(), ae = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), F = hr(ae, t), z = wm(h), [k, Q] = _m(i, c, z), pe = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => O.find((K) => !K.propsRef.current.disabled), [O]), ve = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => O.some((K) => m(K.propsRef.current.value, k)), [O, k]), oe = je((K) => {
    var Le;
    if (d || m(K, k)) return !1;
    let ye = (Le = O.find((Ge) => m(Ge.propsRef.current.value, K))) == null ? void 0 : Le.propsRef.current;
    return ye != null && ye.disabled ? !1 : (Q == null || Q(K), !0);
  }), A = je((K) => {
    let Le = ae.current;
    if (!Le) return;
    let ye = mm(Le), Ge = O.filter((he) => he.propsRef.current.disabled === !1).map((he) => he.element.current);
    switch (K.key) {
      case et.Enter:
        Tm(K.currentTarget);
        break;
      case et.ArrowLeft:
      case et.ArrowUp:
        if (K.preventDefault(), K.stopPropagation(), Ja(Ge, Lt.Previous | Lt.WrapAround) === $n.Success) {
          let he = O.find((qe) => qe.element.current === (ye == null ? void 0 : ye.activeElement));
          he && oe(he.propsRef.current.value);
        }
        break;
      case et.ArrowRight:
      case et.ArrowDown:
        if (K.preventDefault(), K.stopPropagation(), Ja(Ge, Lt.Next | Lt.WrapAround) === $n.Success) {
          let he = O.find((qe) => qe.element.current === (ye == null ? void 0 : ye.activeElement));
          he && oe(he.propsRef.current.value);
        }
        break;
      case et.Space:
        {
          K.preventDefault(), K.stopPropagation();
          let he = O.find((qe) => qe.element.current === (ye == null ? void 0 : ye.activeElement));
          he && oe(he.propsRef.current.value);
        }
        break;
    }
  }), q = je((K) => (w({ type: 0, ...K }), () => w({ type: 1, id: K.id }))), $e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({ value: k, firstOption: pe, containsCheckedOption: ve, disabled: d, compare: m, ...y }), [k, pe, ve, d, m, y]), Fe = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({ registerOption: q, change: oe }), [q, oe]), ue = { ref: F, id: a, role: "radiogroup", "aria-labelledby": C, "aria-describedby": J, onKeyDown: A }, mr = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({ value: k }), [k]), pr = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    if (z !== void 0) return oe(z);
  }, [oe, z]);
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(U, { name: "RadioGroup.Description" }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(S, { name: "RadioGroup.Label" }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Qn.Provider, { value: Fe }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Kn.Provider, { value: $e }, s != null && react__WEBPACK_IMPORTED_MODULE_0__.createElement(jm, { disabled: d, data: { [s]: k || "on" }, overrides: { type: "radio", checked: k != null }, form: o, onReset: pr }), dt({ ourProps: ue, theirProps: v, slot: mr, defaultTag: ip, name: "RadioGroup" })))));
}
let op = "div";
function cp(e, t) {
  var r;
  let n = Jn("RadioGroup.Option"), a = ea("RadioGroup.Option"), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)(), { id: o = `headlessui-radiogroup-option-${i}`, value: s, disabled: c = n.disabled || !1, autoFocus: u = !1, ...d } = e, h = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), v = hr(h, t), [m, y] = Xn(), [w, O] = qn(), C = Un({ value: s, disabled: c });
  dr(() => a.registerOption({ id: o, element: h, propsRef: C }), [o, a, h, C]);
  let S = je((ve) => {
    var oe;
    if (vs(ve.currentTarget)) return ve.preventDefault();
    a.change(s) && ((oe = h.current) == null || oe.focus());
  }), J = ((r = n.firstOption) == null ? void 0 : r.id) === o, { isFocusVisible: U, focusProps: ae } = is({ autoFocus: u }), { isHovered: F, hoverProps: z } = as({ isDisabled: c }), k = n.compare(n.value, s), Q = us({ ref: v, id: o, role: "radio", "aria-checked": k ? "true" : "false", "aria-labelledby": m, "aria-describedby": w, "aria-disabled": c ? !0 : void 0, tabIndex: c ? -1 : k || !n.containsCheckedOption && J ? 0 : -1, onClick: c ? void 0 : S, autoFocus: u }, ae, z), pe = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({ checked: k, disabled: c, active: U, hover: F, focus: U, autofocus: u }), [k, c, F, U, u]);
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(O, { name: "RadioGroup.Description" }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(y, { name: "RadioGroup.Label" }, dt({ ourProps: Q, theirProps: d, slot: pe, defaultTag: op, name: "RadioGroup.Option" })));
}
let lp = "span";
function up(e, t) {
  var r;
  let n = Jn("Radio"), a = ea("Radio"), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)(), o = gs(), s = fr(), { id: c = o || `headlessui-radio-${i}`, value: u, disabled: d = n.disabled || s || !1, autoFocus: h = !1, ...v } = e, m = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), y = hr(m, t), w = xs(), O = Mm(), C = Un({ value: u, disabled: d });
  dr(() => a.registerOption({ id: c, element: m, propsRef: C }), [c, a, m, C]);
  let S = je((ve) => {
    var oe;
    if (vs(ve.currentTarget)) return ve.preventDefault();
    a.change(u) && ((oe = m.current) == null || oe.focus());
  }), { isFocusVisible: J, focusProps: U } = is({ autoFocus: h }), { isHovered: ae, hoverProps: F } = as({ isDisabled: d }), z = ((r = n.firstOption) == null ? void 0 : r.id) === c, k = n.compare(n.value, u), Q = us({ ref: y, id: c, role: "radio", "aria-checked": k ? "true" : "false", "aria-labelledby": w, "aria-describedby": O, "aria-disabled": d ? !0 : void 0, tabIndex: d ? -1 : k || !n.containsCheckedOption && z ? 0 : -1, autoFocus: h, onClick: d ? void 0 : S }, U, F), pe = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({ checked: k, disabled: d, hover: ae, focus: J, autofocus: h }), [k, d, ae, J, h]);
  return dt({ ourProps: Q, theirProps: v, slot: pe, defaultTag: lp, name: "Radio" });
}
let dp = ft(sp), fp = ft(cp), ws = ft(up), hp = Zm, mp = Im, pp = Object.assign(dp, { Option: fp, Radio: ws, Label: hp, Description: mp });
const gp = ({
  timeZone: e,
  onSelect: t,
  value: r,
  slots: n,
  orientation: a = "horizontal",
  loading: i,
  text: o
}) => {
  const [s, c] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), { noSlotsLabel: u = "No slots available" } = o || {}, { bookingInformation: d } = Se(), h = (m) => {
    const y = {
      hour: "numeric",
      minute: "numeric",
      hour12: !0,
      timeZone: e
    };
    return new Intl.DateTimeFormat("en-US", y).format(m);
  }, v = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (m) => {
      const w = {
        ...n == null ? void 0 : n.find(
          (O) => O.eventId === m
        ),
        locationType: d.deliveryMethod ?? "virtual"
      };
      c(w), t(w);
    },
    [t, n]
  );
  return /* @__PURE__ */ f.jsxs("div", { children: [
    i && /* @__PURE__ */ f.jsx("div", { className: "flex justify-center", children: /* @__PURE__ */ f.jsx("span", { className: "loading loading-spinner loading-lg text-primary" }) }),
    !i && _t(n) && /* @__PURE__ */ f.jsx("div", { children: u }),
    !i && !_t(n) && /* @__PURE__ */ f.jsx(
      "fieldset",
      {
        className: I("m-0 p-0 b-0 w-full overflow-visible"),
        "aria-label": "Appointment type",
        children: /* @__PURE__ */ f.jsx(
          pp,
          {
            value: (r == null ? void 0 : r.eventId) ?? "",
            onChange: v,
            className: I({
              "grid grid-cols-3 gap-3": a === "horizontal",
              "flex flex-col gap-3": a === "vertical"
            }),
            children: n == null ? void 0 : n.map((m) => /* @__PURE__ */ f.jsx(tp, { children: /* @__PURE__ */ f.jsx(
              ws,
              {
                value: m.eventId,
                "aria-label": m.slotstart.toISOString(),
                className: I(
                  "relative block cursor-pointer rounded-md px-3 py-4 text-center outline-0 font-medium hover:bg-secondary hover:border-1 hover:border-primary",
                  {
                    "text-slate-800 border-1 border-slate-200  bg-white": (s == null ? void 0 : s.eventId) !== m.eventId,
                    "border-1 border-primary ring-4 ring-secondary text-primary": (s == null ? void 0 : s.eventId) === m.eventId
                  }
                ),
                children: h(m.slotstart)
              },
              m.eventId
            ) }, m.eventId))
          }
        )
      }
    )
  ] });
}, vp = ({
  onBookingError: e,
  opts: t,
  text: r
}) => {
  const {
    title: n = "Schedule an appointment with",
    selectSlot: a = "Select a time slot",
    button: i = "Confirm booking"
  } = r || {}, { allowSchedulingInThePast: o = !1 } = t || {}, { selectedProvider: s, setSelectedSlot: c, bookingInformation: u } = Se(), {
    availabilities: { data: d, loading: h, fetch: v },
    bookAppointment: m
  } = Hn(), [y, w] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), [O, C] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    s && v(s.id);
  }, [s]);
  const S = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => h || Br(d) || _t(d) ? [] : d.filter(
    (k) => y ? Zt(k.slotstart, y) : !1
  ), [d, y, h]), J = (k) => {
    w(k), C(null);
  }, U = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), ae = () => {
    U.current && U.current.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    ae();
  }, [O]);
  const F = (k) => {
    C(k), c(k);
  }, z = (k) => {
    m(k, u.preferences, e);
  };
  return s ? /* @__PURE__ */ f.jsxs("div", { children: [
    /* @__PURE__ */ f.jsxs("div", { className: "flex justify-between items-center pb-6 mb-5 border-b-1 border-slate-200", children: [
      /* @__PURE__ */ f.jsxs("h4", { className: "font-semibold text-xl m-0 text-slate-800", children: [
        n,
        /* @__PURE__ */ f.jsx("br", {}),
        /* @__PURE__ */ f.jsx("span", { className: "text-primary", children: s.name })
      ] }),
      /* @__PURE__ */ f.jsx(
        Bn,
        {
          name: s.name,
          image: s.image,
          classes: "w-24"
        }
      )
    ] }),
    /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx(
      zh,
      {
        value: y,
        onSelect: J,
        allowSchedulingInThePast: o
      }
    ) }),
    y && /* @__PURE__ */ f.jsxs("div", { className: "pt-6 mt-6 border-t-1 border-slate-200", children: [
      /* @__PURE__ */ f.jsxs("div", { className: "mb-4", children: [
        /* @__PURE__ */ f.jsx("h3", { className: "font-semibold text-xl m-0 text-slate-800 text-center", children: a }),
        /* @__PURE__ */ f.jsxs("p", { className: "text-center mt-1", children: [
          "Times in ",
          Intl.DateTimeFormat().resolvedOptions().timeZone
        ] })
      ] }),
      /* @__PURE__ */ f.jsx(
        gp,
        {
          value: O,
          onSelect: F,
          slots: S,
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        }
      )
    ] }),
    y && O && /* @__PURE__ */ f.jsx(
      "div",
      {
        className: "py-6 mt-6 border-t-1 border-slate-200",
        ref: U,
        children: /* @__PURE__ */ f.jsx(
          "button",
          {
            className: I("btn btn-primary w-full"),
            onClick: () => z(O),
            children: i
          }
        )
      }
    )
  ] }) : null;
}, yp = ({
  shouldSkipProviderSelection: e
}) => {
  const t = "Back to providers", r = [
    {
      id: "provider-selection",
      isComplete: e
    },
    {
      id: "scheduling",
      isComplete: !1
    },
    {
      id: "booking-error",
      isComplete: !1
    }
  ], n = r.find(
    (v) => !v.isComplete
  ), [a, i] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(r), [o, s] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(n), c = (v) => () => {
    const m = a.map((w) => w.id === v ? { ...w, isComplete: !0 } : w);
    i(m);
    const y = m.find((w) => !w.isComplete);
    y && s(y);
  }, u = (v) => () => {
    const m = a.find((y) => y.id === v);
    m && s(m);
  }, d = () => {
    i(r), s(n);
  }, h = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => o.id !== "provider-selection", [o.id]);
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    h && /* @__PURE__ */ f.jsxs(
      "a",
      {
        className: "link link-primary mb-4 text-sm no-underline hover:underline",
        onClick: d,
        type: "button",
        children: [
          "< ",
          t
        ]
      }
    ),
    o.id === "provider-selection" && /* @__PURE__ */ f.jsx(
      wf,
      {
        onSelectProvider: c("provider-selection")
      }
    ),
    o.id === "scheduling" && /* @__PURE__ */ f.jsx(vp, { onBookingError: u("booking-error") }),
    o.id === "booking-error" && /* @__PURE__ */ f.jsx(Cf, {})
  ] });
}, Op = ({
  providerId: e,
  providerPreferences: t,
  fetchProviders: r,
  fetchAvailability: n,
  onBooking: a,
  onCompleteActivity: i
}) => {
  const o = !Br(e), s = Wu(
    {},
    {
      location: {
        state: void 0,
        facility: void 0
      },
      gender: void 0,
      ethnicity: void 0,
      language: void 0,
      age: void 0,
      clinicalFocus: void 0,
      therapeuticModality: void 0
    },
    t
  );
  return /* @__PURE__ */ f.jsx(
    jf,
    {
      fetchAvailability: n,
      fetchProviders: r,
      completeActivity: i,
      bookAppointment: a,
      children: /* @__PURE__ */ f.jsx(
        "main",
        {
          id: "ahp_main_content_with_scroll_hint",
          className: "flex-1",
          "data-theme": "sol",
          children: /* @__PURE__ */ f.jsx("div", { className: "max-w-[650px] px-4 py-0 mx-auto my-0 relative", children: /* @__PURE__ */ f.jsx(Pf, { initialPreferences: s, children: /* @__PURE__ */ f.jsx(
            yp,
            {
              shouldSkipProviderSelection: o,
              onCompleteActivity: i
            }
          ) }) })
        }
      )
    }
  );
};

//# sourceMappingURL=index.es.js.map


/***/ })

}]);